import {
  Input,
  Output,
  OnInit,
  Inject,
  EventEmitter,
  OnChanges,
  Component,
  ViewChild,
} from "@angular/core";
import swal from "sweetalert2";
import { FormControl, NgForm } from "@angular/forms";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ProcessingInstruction } from "../../models/processingInstruction";
import { Observable } from "rxjs";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { map, startWith } from "rxjs/operators";
import { UserService } from "../../services/user.service";
import { ProcessingpService } from "../../services/processing.service";
import { POService } from "../../services/po.service";
import { ImageService } from "../../services/image.service";
import { CitaService } from "../../services/cita.service";
import { TransportationService } from "../../services/transportation.service";
import { LogManifestService } from "../../services/logmanifest.service";
import { LogManifest } from "../../models/logManifest";
import { FileService } from "../../services/file.service";
import { LocationService } from "../../services/location.service";
import { GuiGuard } from "../../shared/guard/base-gui-guard";
import { Methods } from "../../shared/methods";
import { WeightItem } from "../../models/weightitem";
import { WeightItemService } from "../../services/weightitem.service";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { ChatLogService } from "../../services/chatlog.service";
import { ChatLog } from "../../models/chatLog";
import { Purchase } from "../../models/purchase";
import { PurchaseService } from "../../services/purchase.service";
import { ReminderService } from "../../services/reminder.service";
import { Containersvice } from "../../services/container.service";
import { Reminder } from "../../models/reminder";
import { TableData } from "../../md/md-table/md-table.component";
import { ContactsFormService } from "../../services/contactsform.service";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { formatDate } from "@angular/common";
import { ReportService } from "../../services/report.service";
import { ConfigService } from "../../services/config.service";
import { MultiFilesService } from "../../services/multifiles.service";
import { ContainerphotosComponent } from "../../shared/components/containerphotos/containerphotos.component";
import { ErasuremethodService } from "../../services/erasuremethod.service";
import { Icon } from "../../models/card-icon";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";

declare const $: any;

export interface UserList {
  value: string;
  name: string;
}

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface option {
  colName: string;
  position: number;
  visibility: boolean;
  tab: number;
}

@Component({
  selector: "app-batch-pi",
  templateUrl: "./batch-pi.component.html",
  styleUrls: ["./batch-pi.component.css"],
  providers: [
    GuiGuard,
    CitaService,
    ImageService,
    WeightItemService,
    LogManifestService,
    FileService,
    TransportationService,
    ProcessingpService,
    LocationService,
    ChatLogService,
    ReminderService,
    ContactsFormService,
    ReportService,
  ],
})
export class BatchPiComponent implements OnInit {
  @ViewChild(MatStepper) stepper!: MatStepper;

  step1Form: FormGroup;
  step2Form: FormGroup;
  step3Form: FormGroup;
  public mtds: Methods = new Methods();
  firstFormGroup: FormGroup;
  public companyLinked = null;
  public titleModal = "PO Details";
  @Input() action: string;
  @Input() id: string = null;
  @Input() poId: number = null;
  @Input() piId: number = null;
  @Input() poNumber = "";
  @Input() frompo = "No";
  @Input() logs: boolean = false;
  @Input() cancel: boolean = false;
  public selectedPoOption = false;
  @Output() batchCreated = new EventEmitter<void>();
  @Output() closeNewBatch = new EventEmitter<void>();
  // @Output() close: EventEmitter<any>;

  @Output() delete_id: EventEmitter<number>;
  iconTitle: Icon = {
    icon: "chrome_reader_mode",
    title: "Add New Batch",
  };
  public syncdone: boolean = false;
  public syncPOPending: boolean = false;
  public identity;
  public editar = false;
  public createPO = false;
  public internal_id = null;
  public showPopLabel = false;
  public loadingSync = false;
  public changeStatus = false;
  public nuevoStatus = "";

  public cant_pending = 0;
  public cant_in_progress = 0;
  public cant_completed = 0;

  public erasureMethods = [];
  public dateReceived = "";
  public manifestCompletedDate = "";
  public testingCompletedDate = "";
  public assignTo = 0;
  public loadingUsers = false;
  public usersList: any[] = [];

  public tableContacts: DinamicData = new DinamicData([
    "ID",
    "Item Type",
    "NET Weight",
    "Damage",
    "Date Received",
    "Location",
    "Rep",
    "Stage",
    "Actions",
  ]);
  public tableTrakings: string[][] = [];

  public asignar = "";
  public sales = "";
  public tech = "";
  public manifest = "";
  public set_id = "";

  public step = "INTRANSIT";
  public image = "local_shipping";
  public progressBar = 12.5;
  public guardando: boolean;
  public cargando: boolean;
  public cargandoBatch: boolean;
  public syncpos: boolean = false;
  public syncposinv: boolean = false;
  public token;
  public repsList: any[] = [];
  public salesList: any[] = [];
  public techList: any[] = [];
  public manifestList: any[] = [];
  public poList: any[] = [];
  public filesCita;
  public citaID: number = null;
  public itemtype;
  public totalNetWeight;
  public itemsweights: Array<WeightItem>;
  public damages;
  public itemIsPi;
  public chats: Array<LogManifest> = [];
  public chatsWeights: Array<ChatLog>;
  public errorContainers: boolean = false;
  public errorHardDrives: boolean = false;
  public errorAllInOne: boolean = false;
  public errorLaptops: boolean = false;
  public errorDesktops: boolean = false;

  public containersProcessed: number = 0;

  public showWarehouseError: boolean = false;

  public trakingNumber = "";
  public expectedDate = "";
  public trakingcomments = "";

  public newTraking = false;
  public deletTraking = false;

  public buscandoTrakings = false;
  public newchatmsg;
  public newchatmsgWeight;
  public jsonChatLog;
  public loading: boolean = false;
  public loading2: boolean = false;
  public respuestapo: any = "";

  public manifestRep: any = "";
  public testingStatusForm: any = "";
  public testingStatus: any = "";

  public createSecondStage: boolean = false;

  public item: ProcessingInstruction;

  public totalWeight = 0;
  public comments = "";
  public privilegio;
  public folderId = "";
  public pobuscador: any;
  public typeofe = "";

  public warehouseList = [];
  public whs_id = null;
  public locationsList = [];
  public location_id = null;
  public loadingLocations = false;

  public ispending = 0;

  public showTraking = false;
  public editId = null;
  public buscando = false;

  //SECCIÓN REMINDERS
  public idcontact;
  public statusContainer;
  public statusContent;
  public contacthistory: Reminder;
  public status_contactHistory;
  //Usuarios Reminders
  filteredArrayUsers: Observable<UserList[]>;
  myControlUsers = new FormControl();
  public usersSeleccionados = [];
  public arrayUsers: any[] = [];

  //public userinterno;
  public editHistory = false;
  public saveEditHistory = false;
  public tableContacts2: TableData;
  public options: Array<option> = [];

  public paymentStatus = "";

  filteredClientes: Observable<UserList[]>;
  clientes: UserList[] = [];

  myControlClientes = new FormControl();

  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );

  public numberNotifications;
  public notificationsData;
  public userlogged;
  public apiCompany;

  public warehouseActivate: boolean = false;

  public reports = false;

  public destructionclientsname: string = "";

  public apikey = "";

  public idChat;
  public itemChat;
  public typeChat;

  public reportID = null;
  public reportCompleted = null;
  public poReport = null;
  public typeReport = "PHYSICALDESTRUCTION";

  public esgReportingBoolean = false;
  public paramTicket = false;

  public typesofequipment = [
    "AIO",
    "eBay",
    "HDD/SSD",
    "Laptops",
    "LCDs",
    "LCDs - Grade A - W/O Stand",
    "LCDs - Grade A - W/Stand",
    "LCDs - Grade B - W/O Stand",
    "LCDs - Grade B - W/Stand",
    "LCDs - Grade C - W/O Stand",
    "LCDs - Grade C - W/Stand",
    "LCDs - Pending Testing",
    "Misc",
    "Networking",
    "PCs",
    "POS",
    "Printers",
    "Scrap",
    "Servers",
    "Telecom",
    "Workstations",
  ];

  public numNotes = 0;
  public numFiles = 0;

  constructor(
    private fb: FormBuilder,
    public guard: GuiGuard,
    private _router: Router,
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _processingSerice: ProcessingpService,
    private _imageService: ImageService,
    private _citaService: CitaService,
    private _poService: POService,
    private _logManifestService: LogManifestService,
    private _fileService: FileService,
    private _transpSservice: TransportationService,
    private _weightItemService: WeightItemService,
    private _locationService: LocationService,
    private _chatLogService: ChatLogService,
    private _purchaseService: PurchaseService,
    public dialog: MatDialog,
    private _reminderService: ReminderService,
    private _ContactFormService: ContactsFormService,
    private _reportService: ReportService,
    private uploadService: MultiFilesService,
    private _erasureService: ErasuremethodService,
    private _configTable: ConfigService,
    private _containerService: Containersvice
  ) {
    this.step1Form = this.fb.group({
      poNumber: ["", Validators.required],
    });
    this.step2Form = this.fb.group({
      containerType: ["", Validators.required],
    });

    this.step3Form = this.fb.group({
      batchInfo: ["", Validators.required],
    });

    this.identity = this._userService.getIdentity();
    this.pobuscador = "";
    this.guardando = false;
    this.cargando = false;
    this.cargandoBatch = false;
    // this.close = new EventEmitter();
    this.delete_id = new EventEmitter();
    this.token = this._userService.getToken();
    this.item = new ProcessingInstruction(this.identity.sub);
    this.getCatalogos();
    this.apikey = this.identity.apiCompany;

    this._userService.getAllUsersType(this.token, "VENDOR").subscribe(
      (response) => {
        console.log(response);
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          this.loading = false;
          // this.pacientes2 = response.data;

          response.data.forEach(
            function (element) {
              //  console.log(element);
              if (element.companyLinked === null) {
              } else {
                this.clientes2.push({
                  value: element.id,
                  name:
                    element.name +
                    " " +
                    element.surname +
                    " # " +
                    element.id +
                    " - " +
                    element.companyLinked.name,
                });
              }
            }.bind(this)
          );
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        console.log(<any>error);
      }
    );

    this._configTable.getConfig("processingmenu").subscribe(
      (r: any) => {
        console.log(r);
        if (r.data) {
          this.options = JSON.parse(r.data.data);
          console.log(this.options);
        } else {
          this.options = [
            {
              colName: "PO Details",
              position: 1,
              visibility: true,
              tab: 1,
            },
            {
              colName: "TRANSPORTATION DETAILS",
              position: 2,
              visibility: true,
              tab: 2,
            },
            {
              colName: "RECEIVING PI",
              position: 3,
              visibility: true,
              tab: 3,
            },
            {
              colName: "MANIFESTING PI",
              position: 4,
              visibility: true,
              tab: 4,
            },
            {
              colName: "TESTING PI",
              position: 5,
              visibility: true,
              tab: 5,
            },
            {
              colName: "DATA SANITIZATION",
              position: 6,
              visibility: true,
              tab: 6,
            },
            {
              colName: "SALES PI",
              position: 7,
              visibility: true,
              tab: 7,
            },
            {
              colName: "WEIGHTS",
              position: 8,
              visibility: true,
              tab: 8,
            },
            {
              colName: "FILES",
              position: 9,
              visibility: true,
              tab: 9,
            },
            {
              colName: "NOTES",
              position: 10,
              visibility: true,
              tab: 10,
            },
            {
              colName: "TICKETS",
              position: 11,
              visibility: true,
              tab: 11,
            },
            {
              colName: "REMINDERS",
              position: 12,
              visibility: true,
              tab: 12,
            },
          ];
        }

        console.log(this.options);
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loading = false;
      }
    );

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    console.log("privilegio");
    console.log(this.privilegio);

    if (this.token) {
      console.log("entramos crud");
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.userlogged = response.data;

            this.companyLinked = response.data.companyLinked;
            this.apiCompany = this.userlogged.companyLinked.apiToken;
            if (this.userlogged.location == null) {
              this.userlogged.location = {};
              this.userlogged.location.id = 0;
            }

            this.whs_id = this.userlogged.location.id;
            if (this.userlogged.internalLocation !== null)
              this.location_id = this.userlogged.internalLocation.id;
            console.log(this.internal_id);
            this.location_id = this.internal_id;

            if (this.whs_id > 0) {
              this.warehouseActivate = false;
            } else {
              this.warehouseActivate = true;
            }
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }

    this._erasureService.showAll().subscribe((response) => {
      console.log(response);
      this.erasureMethods = response.data;
    });

    this.getWarehouse();
    this.getUsers();
  }

  public showAllLocations: boolean = false;

  onCheckboxChange(event) {
    if (event.checked) this.showAllLocations = true;
    else this.showAllLocations = false;

    this.getLocationsNewContainer();
  }

  updateConfig() {
    console.log(this.options);
    this._configTable
      .setConfig("processingmenu", this.options)
      .subscribe((r) => {
        console.log(r);
      });
  }

  public clientSelected = "";
  myControlClientes2 = new FormControl();
  filteredClientes2: Observable<UserList[]>;
  public userinterno;
  public creatingpo = false;

  viewReport() {
    this.reports = true;
  }

  createReport() {
    this.reports = true;
  }

  closeReport(param) {
    this.reportID = param;

    this.reports = false;
  }

  nuevaPO() {
    this.createPO = true;
  }

  showPop() {
    this.showPopLabel = !this.showPopLabel;
    console.log(this.showPopLabel);
  }

  selectClient(option) {
    this.clientSelected = option.value.value;

    this._userService.getUser(this.token, this.clientSelected).subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status == "success") {
          this.loading = false;
          this.userinterno = response.data;
          console.log(this.userinterno);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  isButtonDisabled(): boolean {
    const isDevicesValid =
      this.newContentType === "Devices" &&
      (this.desktops > 0 || this.allInOne > 0 || this.laptops > 0);

    const isHDDValid =
      this.newContentType === "HDD/SSD" &&
      this.caddies &&
      (this.hardDrives > 0 || this.ssd > 0);

    const isMobileValid =
      this.newContentType === "Mobile Devices" && !!this.mobileDevices;

    const isWeightAndLocationValid =
      this.newcontainerWeight >= 1 &&
      this.newcontainerInternallocation_id !== 0;

    // Habilitar el botón solo si se cumple alguna de las condiciones específicas y los valores generales
    return !(
      (isDevicesValid || isHDDValid || isMobileValid) &&
      isWeightAndLocationValid
    );
  }

  creandoPO(form) {
    this.creatingpo = true;
    console.log(this.clientSelected);
    let po: Purchase = new Purchase();

    po.vendor_id = this.userinterno.id;
    po.terms_id = this.userinterno.term;
    po.customerName =
      this.userinterno.name +
      " " +
      this.userinterno.surname +
      " #" +
      this.userinterno.id +
      " - " +
      this.userinterno.companyLinked.name;

    po.contactcontactuser_id = this.userinterno.id;
    po.contactcontact = this.userinterno.name + " " + this.userinterno.surname;
    po.contactphone = this.userinterno.phone;
    po.contactemail = this.userinterno.email;

    po.contactaddress1 = this.userinterno.address1;
    po.contactaddress2 = this.userinterno.address2;
    po.contactcity = this.userinterno.city;
    po.contactstate = this.userinterno.colonia;
    po.contaccountry = this.userinterno.country;
    po.contactpostalcode = this.userinterno.zipCode;
    po.contactcompany = this.userinterno.companyLinked.name;

    po.shipfromcompany = this.userinterno.companyLinked.name;
    po.shipfromcontact = this.userinterno.name + " " + this.userinterno.surname;
    po.shipfromemail = this.userinterno.email;
    po.shipfromphone = this.userinterno.phone;

    if (this.userinterno.location !== null) {
      po.shipfromlocation_id = this.userinterno.location.id;
      po.shipfromaddress1 = this.userinterno.location.address;
      po.shipfromaddress2 = this.userinterno.location.address2;
      po.shipfromcity = this.userinterno.location.city;
      po.shipfromstate = this.userinterno.location.colonia;
      po.shipfromcountry = this.userinterno.location.country;
      po.shipfrompostalcode = this.userinterno.location.zipCode;
    } else {
      po.shipfromlocation_id = "other";
      po.shipfromaddress1 = this.userinterno.address;
      po.shipfromaddress2 = this.userinterno.address2;
      po.shipfromcity = this.userinterno.city;
      po.shipfromstate = this.userinterno.colonia;
      po.shipfromcountry = this.userinterno.country;
      po.shipfrompostalcode = this.userinterno.zipCode;
    }

    this._purchaseService.create(po).subscribe(
      (response) => {
        console.log(response);
        if (response.code === 200) {
          let r = {
            id: response.data.id,
            po: response.data.po,
          };
          po.status = response.data.status;
          this.poList.push(r);
          this.item.po.name = response.data.po;
          this.item.po.id = response.data.id;
          this.save(form);
          this.mtds.notifySuccess("PO created successfully");
          this.createPO = false;
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.creatingpo = false;
      },
      (error) => {
        console.log(error);
        if (error.status === 500) {
          this.mtds.notifyError("Error!");
        } else {
          this.mtds.notifyError(error.statusText, error.status);
        }

        this.creatingpo = false;
      }
    );
  }

  isNumber(val): boolean {
    return typeof val === "number";
  }

  cancelAssign() {
    this.asignar = "";
    this.set_id = "";
    this.changeStatus = false;
    this.nuevoStatus = "";
  }

  syncPO(po) {
    this.respuestapo = "";
    this.loadingSync = true;
    this.syncPOPending = true;
    console.log(po);
    this._purchaseService.newsync(po.id, "SYNCPOFROMIQ").subscribe(
      (e) => {
        console.log(e);

        swal.fire({
          title: e.status,
          text: e.msg,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        this.syncPOPending = false;
        this.loadingSync = false;
      },
      (error) => {
        console.log(error);
        this.syncPOPending = false;
        this.loadingSync = false;
        swal.fire({
          title: "ERROR!",
          text: "Something went wrong",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    );
    /*this._processingSerice.syncInventory(po).subscribe(response => {
      
      this.respuestapo = response;
         this.syncPOPending = false;
       
        if(response.status == 200){

          let body = this.respuestapo._body;
          body = JSON.parse(body);
          console.log(body);
         
         if(body.status == 'success')
            alert("PO " + po + " has been has been synchronized");
         else
            alert(body.data);
        }else{
          alert("Error, something went wrong");
         
        }

      },
      error => {
        console.log(<any>error);

      });*/
  }

  markasPaid() {
    this.guardando = true;
    this._processingSerice.markaspaid(this.token, this.item.id).subscribe(
      (response) => {
        console.log(response);
        this.guardando = false;
        if (response.status == "success") {
          this.item.isPaid = 1;

          this.mtds.notifySuccess("PO has been marked as paid");
        } else {
          this.guardando = false;
          alert("Error");
        }
      },
      (error) => {
        alert("Error");
      }
    );
  }

  testingComplete() {
    this.guardando = true;
    this._processingSerice
      .marktestingComplete(this.token, this.item.id)
      .subscribe(
        (response) => {
          console.log(response);
          this.guardando = false;
          if (response.status == "success") {
            this.testingStatus = "Completed";
            this.testingStatusForm = "Completed";
            this.mtds.notifySuccess("Testing has been completed");

            this.myWebSocket.next({
              notify: "1",
              data: this.item.id,
              type: "TESTINGCOMPLETED",
              token: this.token,
              action: "UPDATE", // NEW ó UPDATE ó DELETE
              texto: this.item.po.name,
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          } else {
            this.guardando = false;
            alert("Error");
          }
          this.savingErasure = true;
        },
        (error) => {
          alert("Error");
          this.savingErasure = true;
        }
      );
  }

  markcompleted() {
    this.guardando = true;
    this._processingSerice
      .markmanifeststatusprocessed(this.token, this.item.id)
      .subscribe(
        (response) => {
          console.log(response);
          this.guardando = false;
          if (response.status == "success") {
            this.item.manifestStatus = "Completed";
            this.mtds.notifySuccess("Manifest has been completed");

            if (this.item.manifest === "Yes") {
              this.myWebSocket.next({
                notify: "1",
                data: this.item.id,
                type: "MANIFESTCOMPLETED",
                token: this.token,
                action: "UPDATE", // NEW ó UPDATE ó DELETE
                texto: this.item.po.name,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }
          } else {
            this.guardando = false;
            alert("Error");
          }
          this.savingErasure = true;
        },
        (error) => {
          alert("Error");
          this.savingErasure = true;
        }
      );
  }

  markProcessed() {
    this.guardando = true;
    this._processingSerice.markpoprocessed(this.token, this.item.id).subscribe(
      (response) => {
        console.log(response);
        this.guardando = false;
        if (response.status == "success") {
          //this.item.manifestStatus = 'Completed';
          this.mtds.notifySuccess("PO has been processed");

          this.myWebSocket.next({
            notify: "1",
            data: this.item.id,
            type: "PI-STATUS",
            token: this.token,
            action: "PROCESSED", // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );
        } else {
          this.guardando = false;
          alert("Error");
        }
        this.savingErasure = true;
      },
      (error) => {
        alert("Error");
        this.savingErasure = true;
      }
    );
  }

  cambiarStatus() {
    this.guardando = true;
    this._processingSerice
      .updateStatus(this.token, this.item.id, this.nuevoStatus)
      .subscribe(
        (response) => {
          this.guardando = false;
          if (response.status == "success") {
            this.step = this.nuevoStatus;
            this.changeprogressValue();
            this.cancelAssign();
            this.myWebSocket.next({
              notify: "1",
              data: this.item.id,
              type: "PI-STATUS",
              token: this.token,
              action: this.step, // NEW ó UPDATE ó DELETE
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          } else {
            this.guardando = false;
            alert("Error");
          }
          this.savingErasure = true;
        },
        (error) => {
          alert("Error");
          this.savingErasure = true;
        }
      );
  }

  cambiandoStatus() {
    console.log(this.step);
    this.nuevoStatus = this.step;
    this.changeStatus = true;
  }

  getWarehouse() {
    this._locationService.getLocations(this.token).subscribe(
      (response) => {
        console.log(response);
        if (response.status === "success") {
          this.warehouseList = response.data;
        } else {
          this.showSwal("error", "ERROR!", response.msg);
        }
        this.loading = false;
      },
      (error) => {
        console.log(<any>error);
        this.showSwal("error");
        this.loading = false;
      }
    );
  }

  getLocations() {
    if (
      (this.whs_id != null &&
        this.whs_id > 0 &&
        this.itemtype !== "" &&
        this.itemtype !== null) ||
      this.totalWeight < 0
    ) {
      this.loadingLocations = true;
      let json;
      json = {
        item: this.itemtype,
        totalNetWeight: this.totalWeight,
      };
      // this.location_id = null;

      this._locationService
        .getAvailables(this.token, this.whs_id, json)
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              let flat = false;
              this.locationsList = [];
              for (let item of response.data) {
                let location = {
                  id: item.id,
                  name:
                    item.locationName +
                    ": " +
                    item.locationRow +
                    "-" +
                    item.locationBay +
                    "-" +
                    item.locationLevel +
                    "-" +
                    item.locationSection,
                  linkTo: item.linkTo,
                };
                this.locationsList.push(location);
                if (this.location_id === item.id) {
                  flat = true;
                }
              }

              if (
                !flat &&
                this.location_id !== null &&
                this.location_id !== ""
              ) {
                let location = {
                  id: this.location_id,
                  name: this.location_name,
                };
                this.locationsList.push(location);
              }
            } else {
              this.showWarehouseError = true;
            }
            this.loadingLocations = false;
          },
          (error) => {
            this.loadingLocations = false;
            console.log(<any>error);
            this.showSwal("error");
          }
        );
    }
  }

  assign(assign = null) {
    if (assign === null) {
      assign = this.asignar;
    }

    this._processingSerice
      .asign(this.token, this.item.id, assign, this.set_id)
      .subscribe(
        (response) => {
          if (assign === "settech") {
            this.tech =
              response.msg.tech.name + " " + response.msg.tech.surname;
          } else if (assign === "setsales") {
            this.sales =
              response.msg.sales.name + " " + response.msg.sales.surname;
          } else if (assign === "setmanifest") {
            this.manifest =
              response.msg.manifest.name + " " + response.msg.manifest.surname;
          } else if (assign === "unassignsales") {
            this.sales = "";
          } else if (assign === "unassigntech") {
            this.tech = "";
          } else if (assign === "unassignmanifest") {
            this.manifest = "";
          }

          if (
            assign === "settech" ||
            assign === "setsales" ||
            assign === "setmanifest"
          ) {
            this.myWebSocket.next({
              notify: "1",
              data: this.item.id,
              type: "PO-ASSIGNED",
              token: this.token,
              action: "NEW", // NEW ó UPDATE ó DELETE
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          }

          this.cancelAssign();
        },
        (error) => {
          alert("Error!");
        }
      );
  }

  sync() {
    this.syncpos = true;
    this._processingSerice.sync().subscribe(
      (response) => {
        console.log(response);
        this.syncpos = false;

        if (response.status === 200) {
          this.getCatalogos();
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  syncInventory(po) {
    console.log(po);
    /*console.log(po.value);
    console.log(po.name);*/
    this.syncposinv = true;
    this._processingSerice.syncInventory(po).subscribe(
      (response) => {
        console.log(response);
        if (response.status === 200) {
          // this.getCatalogos();
          this.syncposinv = false;
          this.showSwal("success", "Inventory Sync Successfully!");
        } else {
          this.syncposinv = false;
          this.showSwal("error");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  sendMessage(message: string) {
    message = message.trim();
    if (message.length > 0) {
      //this.messages.push(message);
      this.newchatmsg = message;
      this.sendChat();
    }
  }

  sendMessageWeights(message: string) {
    message = message.trim();
    if (message.length > 0) {
      //this.messages.push(message);
      this.newchatmsg = message;
      this.sendChatWeights();
    }
  }

  deleteChat(id) {
    this.idChat = id;

    if (confirm("Are you sure you want to delete this chat?")) {
      this.saving = true;
      this._logManifestService.remove(this.token, this.idChat).subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwal("error", response.msg, response.longmsg);
            } else {
              this.showSwal("error", "ERROR!", response.msg);
            }
          } else {
            this.showSwal(
              "success",
              "Chat removed!",
              "The chat has been removed successfully"
            );
            this.getChat();
          }
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.showSwal("error");
        }
      );
    }
  }

  deleteChatWeights(id) {
    this.idChat = id;

    if (confirm("Are you sure you want to delete this chat?")) {
      this.saving = true;
      this._chatLogService.remove(this.token, this.idChat).subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwal("error", response.msg, response.longmsg);
            } else {
              this.showSwal("error", "ERROR!", response.msg);
            }
          } else {
            this.showSwal(
              "success",
              "Chat removed!",
              "The chat has been removed successfully"
            );
            this.getChatWeights();
          }
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.showSwal("error");
        }
      );
    }
  }

  sendChat() {
    this.loading = true;

    let enviar;
    enviar = {
      message: this.newchatmsg,
      pi_id: this.id,
    };

    this._logManifestService.create(this.token, enviar).subscribe(
      (response) => {
        this.loading = false;
        if (response.status === "success") {
          console.log(response.data);

          this.chats.push(response.data);

          this.myWebSocket.next({
            notify: "1",
            data: this.id,
            type: "NEW-LOG",
            token: this.token,
            action: response.data.rep.name + " " + response.data.rep.surname, // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.myWebSocket.next({
            notify: "1",
            data: this.id,
            type: "NOTETAGGED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
            toDestiny: "USERS",
            toData: this.newchatmsg,
            element: this.item.po.id,
            texto: this.item.po.name,
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.newchatmsg = "";
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  getChatWeights() {
    //console.log(this.item.id);
    this.jsonChatLog = {
      type: "CONTAINERINVENTORY",
    };
    this._chatLogService
      .getChat(this.token, this.itemEditar, this.jsonChatLog)
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.chatsWeights = response.data;
            //console.log(this.chats);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  sendChatWeights() {
    this.loading2 = true;

    let enviar;
    enviar = {
      message: this.newchatmsg,
      father_id: this.itemEditar,
      type: "CONTAINERINVENTORY",
    };

    this._chatLogService.create(this.token, enviar).subscribe(
      (response) => {
        this.loading2 = false;
        if (response.status === "success") {
          console.log(response.data);

          this.chatsWeights.push(response.data);

          this.myWebSocket.next({
            notify: "1",
            data: this.itemEditar,
            type: "CONTAINER-NOTE-ADDED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.myWebSocket.next({
            notify: "1",
            data: this.itemEditar,
            type: "CONTAINERTAGGED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
            toDestiny: "USERS",
            toData: this.newchatmsg,
            element: this.itemEditar,
            texto: this.itemEditar,
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.newchatmsg = "";
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  convertNumber(cantidad: number) {
    if (Number(this.item.originalTotalCostPo) < cantidad) {
      return false;
    }

    return true;
  }

  actions(e) {
    console.log(e);

    this.editId = e.id;

    switch (e.evento) {
      case "show": {
        this.newTraking = true;
        this.showTraking = true;
        this.trakingNumber = e.row[1];
        this.expectedDate = e.row[2];
        this.trakingcomments = e.row[3];
        break;
      }
      case "delete": {
        this.deletTraking = true;
        break;
      }
    }
  }

  deleteTraking() {
    this.guardando = true;

    this._transpSservice.delete(this.editId).subscribe(
      (response) => {
        if (response.status === "success") {
          this.endTraking();
          this.getTrakings();
        } else {
          alert("Error!");
        }
        this.guardando = false;
      },
      (error) => {
        alert("Error!");
        this.guardando = false;
      }
    );
  }

  saveTraking() {
    this.guardando = true;

    let data;
    data = {
      po_id: this.item.po.id,
      expectedDate: this.expectedDate,
      trackingNumber: this.trakingNumber,
      comments: this.trakingcomments,
    };

    if (this.editId === null) {
      this._transpSservice.create(data).subscribe(
        (response) => {
          if (response.status === "success") {
            this.endTraking();
            this.getTrakings();
          } else {
            alert("Error!");
          }
          this.guardando = false;
        },
        (error) => {
          alert("Error!");
          this.guardando = false;
        }
      );
    } else {
      this._transpSservice.update(data, this.editId).subscribe(
        (response) => {
          if (response.status === "success") {
            this.endTraking();
            this.getTrakings();
          } else {
            alert("Error!");
          }
          this.guardando = false;
        },
        (error) => {
          alert("Error!");
          this.guardando = false;
        }
      );
    }
  }

  getTrakings() {
    this.tableTrakings = [];
    this.buscandoTrakings = true;

    this._transpSservice.showAll(this.item.po.id).subscribe((response) => {
      // console.log('Traking service:');
      // console.log(response);

      response.data.forEach(
        function (element) {
          this.tableTrakings.push([
            element.id,
            element.trackingNumber,
            this.getFecha(new Date(element.expectedDate)),
            element.comments,
          ]);
        }.bind(this)
      );
      this.buscandoTrakings = false;
    });
  }

  endTraking() {
    this.trakingNumber = "";
    this.expectedDate = "";
    this.trakingcomments = "";
    this.showTraking = false;
    this.newTraking = false;
    this.deletTraking = false;
    this.editId = null;
  }
  stepCompleted: boolean[] = [false, false];
  OnHumanSelected(option) {
    console.log(option, "optiooooooon");
    this.item.po.name = option.value.name;
    this.item.po.id = option.value.value;
    this.selectedPoOption = true;
    this.updateStepCompletion(0, this.pobuscador || this.selectedPoOption);
    this.errorHdShredding = false;
  }
  updateStepCompletion(stepIndex: number, isComplete: boolean) {
    this.stepCompleted[stepIndex] = isComplete;
  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name;

    return this.clientes.filter((option) =>
      String(option.name).toLowerCase().startsWith(filterValue)
    );
  }

  changeprogressValue() {
    let value: number;
    switch (this.step) {
      case "INTRANSIT":
        this.image = "local_shipping";
        value = 12.5;
        break;
      case "PICKEDUP":
        this.image = "assignment_returned";
        value = 25;
        break;
      case "RECEIVED":
        this.image = "assignment_turned_in";
        value = 37.5;
        break;
      case "REMOVINGDATABEARINGDEVICES":
        this.image = "delete_forever";
        value = 50;
        break;
      case "INMANIFEST":
        this.image = "description";
        value = 62.5;
        break;
      case "INTESTING":
        this.image = "assignment";
        value = 75;
        break;
      case "INSALES":
        this.image = "monetization_on";
        value = 87.5;
        break;
      case "PROCESSED":
        this.image = "done_outline";
        value = 100;
        break;
    }

    if (this.progressBar < value) {
      do {
        this.progressBar = this.progressBar + 0.1;
      } while (this.progressBar < value);
    } else if (this.progressBar > value) {
      do {
        this.progressBar = this.progressBar - 0.1;
      } while (this.progressBar > value);
    }
  }

  getChat() {
    this._logManifestService.getChat(this.token, this.id).subscribe(
      (response) => {
        if (response.status === "success") {
          this.chats = response.data;
          console.log(this.chats);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }
  public loadingclients = false;

  getCatalogos() {
    this.loadingclients = true;

    this.cargando = true;
    let indice = 3;
    this.repsList = [];
    this.poList = [];
    this.clientes = [];
    this._userService.getAllUsersType(this.token, "workers").subscribe(
      (response) => {
        if (response.status === "success") {
          console.log("Obteniendo los reps:");
          console.log(response);
          this.repsList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._userService.getAllUsersLite(this.token, "SALESREP").subscribe(
      (response) => {
        if (response.status === "success") {
          this.salesList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._userService.getAllUsersLite(this.token, "TECHREP").subscribe(
      (response) => {
        if (response.status === "success") {
          this.techList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._userService.getAllUsersLite(this.token, "MANIFESTREP").subscribe(
      (response) => {
        if (response.status === "success") {
          this.manifestList = response.data;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this._processingSerice.getListPILite(this.token).subscribe(
      (response) => {
        if (response.status === "success") {
          this.poList = response.data;
          response.data.forEach(
            function (element) {
              //  console.log(element);
              this.clientes.push({ value: element.id, name: element.po });
            }.bind(this)
          );
        }
        if (this.clientes) {
          this.loadingclients = false;
        }
        this.loadingFalse(indice--);
      },
      (error) => {
        console.log(<any>error);
        this.loadingFalse(indice--);
      }
    );

    this.filteredClientes = this.myControlClientes.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterClientes(name) : this.clientes.slice()))
    );

    console.log(this.filteredClientes);
  }

  loadingFalse(indice: number) {
    if (indice === 0) {
      this.cargando = false;
    }
  }

  itemAction(e) {
    console.log(e);
    switch (e.action) {
      case "Photos": {
        this.openPhotos(JSON.parse(e.id));
        break;
      }
      case "Show": {
        this.showItem(JSON.parse(e.id));
        break;
      }
      case "Print": {
        this.print(JSON.parse(e.id));
        // window.open('https://www.greenteksolutionsllc.com/backend/reports/wipe-room-form.php?id=' + e.id, "_blank");
        break;
      }
      case "Remove": {
        this.deleteItemWeight(e.id);
        break;
      }
    }
    //  showItem(row)
    // print(row[0])
    // deleteItemWeight(row[0])
  }

  openPhotos(item) {
    console.log(item);
    const dialog = this.dialog.open(ContainerphotosComponent, {
      width: "60%",
      data: item,
    });

    dialog.afterClosed().subscribe((result) => {
      this.getItemsWeights();
    });
  }

  openChangeLocation(e) {
    console.log(e);

    /*
        let dialogRef = this.dialog.open(ChangeLocation, {
          width: '80%',
            data: { data: e},
            disableClose: true
        });
    
        dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != 'undefined') {
            
          }
        });*/
  }

  guardandoWeigth = false;

  saveWeights() {
    this.guardandoWeigth = true;
    let met, enviar;
    met = this;
    enviar = {
      po_id: this.item.po.id,
      item: this.itemtype,
      weight: this.totalWeight,
      totalNetWeight: this.totalNetWeight,
      damages: this.damages,
      comments: this.comments,
      internallocation_id: this.location_id,
      is_pi: this.itemIsPi,
      typeEquipment: this.typeofe,
      pictureRequired: this.item.pictureRequired,
    };

    console.log(this.locationsList);

    if (this.createSecondStage) {
      var result = this.locationsList.filter((obj) => {
        return obj.linkTo === "PROCESSED";
      });

      enviar.internallocation_id = result[0].id;

      console.log(enviar);
    }

    this._weightItemService.create(this.token, enviar).subscribe(
      (response) => {
        console.log(response);
        if (response.status === "success") {
          if (this.createSecondStage) {
            enviar = {
              po_id: this.item.po.id,
              item: this.itemtype,
              weight: this.totalWeight,
              totalNetWeight: this.totalNetWeight,
              damages: this.damages,
              comments: this.comments,
              internallocation_id: this.location_id,
              is_pi: this.itemIsPi,
              typeEquipment: this.typeofe,
              pictureRequired: this.item.pictureRequired,
            };

            this._weightItemService
              .create(this.token, enviar)
              .subscribe((response2) => {
                if (response.status === "success") {
                  console.log(response2);
                  swal
                    .fire({
                      title:
                        "Item added successfully created with id#: " +
                        response2.data.id,
                      text: "",

                      showCancelButton: true,
                      buttonsStyling: false,

                      customClass: {
                        confirmButton: "btn btn-warning",
                        cancelButton: "btn btn-success",
                      },
                      confirmButtonColor: "#3085d6",
                      confirmButtonText:
                        response2.data.pictureRequired ||
                        response2.data.damages === "Yes"
                          ? "Photos"
                          : "Print",
                      cancelButtonText: "Ok",
                    })
                    .then(
                      function (result) {
                        if (result.value) {
                          if (
                            response2.data.pictureRequired ||
                            response2.data.damages === "Yes"
                          ) {
                            const dialog = this.dialog.open(
                              ContainerphotosComponent,
                              {
                                width: "60%",
                                data: {
                                  container_id: response2.data.id,
                                  type: response2.data.item,
                                  po: response2.data.item.po
                                    ? response2.data.item.po.po
                                    : null,
                                },
                              }
                            );

                            dialog.afterClosed().subscribe((result) => {
                              this.getItemsWeights();
                            });
                          } else {
                            window.open(
                              "https://www.itaderp.com/backend/reports/weight-labels.php?idweight=" +
                                response2.data.id +
                                "&apikey=" +
                                this.apikey
                            );
                          }
                        }
                      }.bind(this)
                    );
                }
              });
          } else {
            swal
              .fire({
                title:
                  "Item added successfully created with id#: " +
                  response.data.id,
                text: "",

                showCancelButton: true,
                buttonsStyling: false,

                customClass: {
                  confirmButton: "btn btn-warning",
                  cancelButton: "btn btn-success",
                },
                confirmButtonColor: "#3085d6",
                confirmButtonText:
                  response.data.pictureRequired ||
                  response.data.damages === "Yes"
                    ? "Photos"
                    : "Print",
                cancelButtonText: "Ok",
              })
              .then(
                function (result) {
                  if (result.value) {
                    if (
                      response.data.pictureRequired ||
                      response.data.damages === "Yes"
                    ) {
                      const dialog = this.dialog.open(
                        ContainerphotosComponent,
                        {
                          width: "60%",
                          data: {
                            container_id: response.data.id,
                            type: response.data.item,
                            po: response.data.item.po
                              ? response.data.item.po.po
                              : null,
                          },
                        }
                      );
                      dialog.afterClosed().subscribe((result) => {
                        this.getItemsWeights();
                      });
                    } else {
                      window.open(
                        "https://www.itaderp.com/backend/reports/weight-labels.php?idweight=" +
                          response.data.id +
                          "&apikey=" +
                          this.apikey
                      );
                    }
                  }
                }.bind(this)
              );
          }

          // this.itemtype = null;
          // met.showNotification('bottom', 'right', 'success', 'Item added successfully');

          // debugger
          if (this.step === "INTRANSIT") {
            this.step = "PICKEDUP";
          }
          this.getItemsWeights();
          this.totalNetWeight = null;
          this.itemIsPi = null;
          this.totalWeight = 0;
          this.comments = "";
          if (!this.lockitemtype) {
            this.itemtype = "";
          }
          if (!this.lockdamage) {
            this.damages = "";
          }
          if (!this.locktypeofequipment) {
            this.typeofe = "";
          }
        } else {
          met.showNotification(
            "bottom",
            "right",
            "danger",
            "Some error has ocurred"
          );
        }
        this.guardandoWeigth = false;
      },
      (error) => {
        console.log(<any>error);
        this.guardandoWeigth = false;
      }
    );
  }

  public total_items_count: number = 0;
  public internalName = "";

  public hideprocessed = false;
  public showall = false;

  public getItemsWeights() {
    let met;
    met = this;
    this.tableContacts.rows = [];
    this.buscando = true;
    let params = { hideprocessed: this.hideprocessed, showall: this.showall };
    this._weightItemService
      .getItemsByFather(this.token, 1, this.item.po.id, params)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status === "success") {
            if (this.userlogged.internalLocation !== null)
              this.location_id = this.userlogged.internalLocation.id;

            this.total_items_count = response.total_items_count;
            this.itemsweights = response.data;
            // console.log(this.itemsweights);
            this.tableContacts.rows = [];
            let contarElementos = 1;
            for (let element of response.data) {
              this.internalName = "";
              let internalId = "";
              if (element.internalLocation !== null) {
                internalId = element.internalLocation.id;
                this.internalName =
                  element.internalLocation.locationName +
                  ": " +
                  element.internalLocation.locationRow +
                  " - " +
                  element.internalLocation.locationBay +
                  " - " +
                  element.internalLocation.locationLevel +
                  " - " +
                  element.internalLocation.locationSection;
              }

              let valorisPI = element.isPi;
              if (valorisPI == 0) valorisPI = "2nd";
              else if (valorisPI == 1) valorisPI = "1st";
              else if (valorisPI == 3) valorisPI = "3rd";
              else if (valorisPI == 4) valorisPI = "4th";

              let actionButtons = [];
              if (element.pictureRequired || element.damages === "Yes") {
                actionButtons.push({
                  icon: "collections",
                  action: "Photos",
                  color: "primary",
                  value: JSON.stringify({
                    container_id: element.id,
                    type: element.item,
                    po: element.po ? element.po.po : null,
                  }),
                });
              }
              actionButtons.push({
                icon: "remove_red_eye",
                action: "Show",
                color: "info",
                value: JSON.stringify(element),
              });
              if (
                (!element.pictureRequired && element.damages !== "Yes") ||
                element.numPhotos
              ) {
                actionButtons.push({
                  icon: "print",
                  action: "Print",
                  color: "dark",
                  value: JSON.stringify({
                    id: element.id,
                    num: contarElementos,
                  }),
                });
              }
              actionButtons.push({
                icon: "delete_outline",
                action: "Remove",
                color: "danger",
                value: element.id,
              });

              this.tableContacts.rows.push([
                new Cell(element.id),
                new Cell(element.item),
                new Cell(element.totalNetWeight),
                new Cell(element.damages),
                //  new Cell(element.weight),
                //  new Cell(element.comments),
                //  new Cell(contarElementos),
                new Cell(element.createdAt, { type: "date" }),
                new Cell(this.internalName),
                //  new Cell(internalId),
                //  new Cell(element.typeEquipment !== null ? element.typeEquipment : ""),
                new Cell(
                  element.rep !== null
                    ? element.rep.name + " " + element.rep.surname
                    : ""
                ),
                new Cell(valorisPI),
                //  new Cell(element.pending),
                new Cell(actionButtons, { type: "actions" }),
              ]);
              contarElementos++;
            }
          }
          this.buscando = false;
        },
        (error) => {
          this.buscando = false;
          console.log(<any>error);
        }
      );
  }

  goToManifest() {
    this._processingSerice
      .recived(this.token, this.item.id, "1")
      .subscribe((response2) => {
        if (response2.status === "success") {
          this.itemsOnDepartament.numInmanifest = response2.data.numInmanifest;
          this.itemsOnDepartament.numInsales = response2.data.numInsales;
          this.itemsOnDepartament.numIntesting = response2.data.numIntesting;
          this.itemsOnDepartament.numReceived = response2.data.numReceived;
          this.itemsOnDepartament.num_processed = response2.data.numProcessed;

          this.itemsOnDepartament.num_inmanifest_second =
            response2.data.numInmanifestSecond;
          this.itemsOnDepartament.num_insales_second =
            response2.data.numInsalesSecond;
          this.itemsOnDepartament.num_intesting_second =
            response2.data.numIntestingSecond;
          this.itemsOnDepartament.num_received_second =
            response2.data.numReceivedSecond;
          this.itemsOnDepartament.num_processed_second =
            response2.data.numProcessedSecond;

          this.itemsOnDepartament.num_inmanifest_third =
            response2.data.numInmanifestThird;
          this.itemsOnDepartament.num_insales_third =
            response2.data.numInsalesThird;
          this.itemsOnDepartament.num_intesting_third =
            response2.data.numIntestingThird;
          this.itemsOnDepartament.num_received_third =
            response2.data.numReceivedThird;
          this.itemsOnDepartament.num_processed_third =
            response2.data.numProcessedThird;

          this.itemsOnDepartament.num_inmanifest_fourth =
            response2.data.numInmanifestFour;
          this.itemsOnDepartament.num_insales_fourth =
            response2.data.numInsalesFour;
          this.itemsOnDepartament.num_intesting_fourth =
            response2.data.numIntestingFour;
          this.itemsOnDepartament.num_received_fourth =
            response2.data.numReceivedFour;
          this.itemsOnDepartament.num_processed_fourth =
            response2.data.numProcessedFour;

          this.itemsOnDepartament.beenInmanifest =
            response2.data.beenInmanifest;
          this.itemsOnDepartament.beenInsales = response2.data.beenInsales;
          this.itemsOnDepartament.beenIntesting = response2.data.beenIntesting;
          this.itemsOnDepartament.beenReceived = response2.data.beenReceived;

          console.log(response2);
          this.step = response2.data.status;
          if (this.item.manifest_priority_level === "FASTPRIORITY") {
            this.myWebSocket.next({
              notify: "1",
              data: this.item.id,
              type: "PI-FAST-RECEIVED",
              token: this.token,
              action: "UPDATE", // NEW ó UPDATE ó DELETE
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          }

          if (this.item.poPriorityLevel === "FASTPRIORITY") {
            this.myWebSocket.next({
              notify: "1",
              data: this.item.id,
              type: "PI-TECHFAST-RECEIVED",
              token: this.token,
              action: "UPDATE", // NEW ó UPDATE ó DELETE
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          }

          this.recived = "1";
          if (this.step === "PICKEDUP") {
            // if (this.item.manifest === 'No') {
            //   this._processingSerice.updateStatus(this.token, this.item.id, 'INTESTING');
            //   this.step = 'INTESTING';
            // } else {
            //   this._processingSerice.updateStatus(this.token, this.item.id, 'INMANIFEST');
            //   this.step = 'INMANIFEST';
            // }

            this.myWebSocket.next({
              notify: "1",
              data: this.item.id,
              type: "PI-STATUS",
              token: this.token,
              action: this.step, // NEW ó UPDATE ó DELETE
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          }
        }
      });
  }

  desbloquear() {
    this._processingSerice
      .recived(this.token, this.item.id, "0")
      .subscribe((response) => {
        if (response.status === "success") {
          this.itemsOnDepartament.numInmanifest = response.data.numInmanifest;
          this.itemsOnDepartament.numInsales = response.data.numInsales;
          this.itemsOnDepartament.numIntesting = response.data.numIntesting;
          this.itemsOnDepartament.numReceived = response.data.numReceived;
          this.itemsOnDepartament.num_processed = response.data.numProcessed;

          this.itemsOnDepartament.num_inmanifest_second =
            response.data.numInmanifestSecond;
          this.itemsOnDepartament.num_insales_second =
            response.data.numInsalesSecond;
          this.itemsOnDepartament.num_intesting_second =
            response.data.numIntestingSecond;
          this.itemsOnDepartament.num_received_second =
            response.data.numReceivedSecond;
          this.itemsOnDepartament.num_processed_second =
            response.data.numProcessedSecond;

          this.itemsOnDepartament.num_inmanifest_third =
            response.data.numInmanifestThird;
          this.itemsOnDepartament.num_insales_third =
            response.data.numInsalesThird;
          this.itemsOnDepartament.num_intesting_third =
            response.data.numIntestingThird;
          this.itemsOnDepartament.num_received_third =
            response.data.numReceivedThird;
          this.itemsOnDepartament.num_processed_third =
            response.data.numProcessedThird;

          this.itemsOnDepartament.num_inmanifest_fourth =
            response.data.numInmanifestFour;
          this.itemsOnDepartament.num_insales_fourth =
            response.data.numInsalesFour;
          this.itemsOnDepartament.num_intesting_fourth =
            response.data.numIntestingFour;
          this.itemsOnDepartament.num_received_fourth =
            response.data.numReceivedFour;
          this.itemsOnDepartament.num_processed_fourth =
            response.data.numProcessedFour;

          this.itemsOnDepartament.beenInmanifest = response.data.beenInmanifest;
          this.itemsOnDepartament.beenInsales = response.data.beenInsales;
          this.itemsOnDepartament.beenIntesting = response.data.beenIntesting;
          this.itemsOnDepartament.beenReceived = response.data.beenReceived;
          this.recived = "0";
        }
      });
  }

  showNotification(from: any, align: any, type, message) {
    const color = Math.floor(Math.random() * 6 + 1);

    $.notify(
      {
        icon: "notifications",
        message: message,
      },
      {
        type: type,
        timer: 3000,
        z_index: 999999,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }

  deleteItemWeight(iditem) {
    swal
      .fire({
        title: "Are you sure you want to delete this container?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            this.buscando = true;
            this._weightItemService.deleteItem(this.token, iditem).subscribe(
              (response) => {
                if (response.status === "success") {
                  this.itemsOnDepartament.numInmanifest =
                    response.datapi.numInmanifest;
                  this.itemsOnDepartament.numInsales =
                    response.datapi.numInsales;
                  this.itemsOnDepartament.numIntesting =
                    response.datapi.numIntesting;
                  this.itemsOnDepartament.numReceived =
                    response.datapi.numReceived;
                  this.itemsOnDepartament.num_processed =
                    response.datapi.numProcessed;

                  this.itemsOnDepartament.num_inmanifest_second =
                    response.datapi.numInmanifestSecond;
                  this.itemsOnDepartament.num_insales_second =
                    response.datapi.numInsalesSecond;
                  this.itemsOnDepartament.num_intesting_second =
                    response.datapi.numIntestingSecond;
                  this.itemsOnDepartament.num_received_second =
                    response.datapi.numReceivedSecond;
                  this.itemsOnDepartament.num_processed_second =
                    response.datapi.numProcessedSecond;

                  this.itemsOnDepartament.num_inmanifest_third =
                    response.datapi.numInmanifestThird;
                  this.itemsOnDepartament.num_insales_third =
                    response.datapi.numInsalesThird;
                  this.itemsOnDepartament.num_intesting_third =
                    response.datapi.numIntestingThird;
                  this.itemsOnDepartament.num_received_third =
                    response.datapi.numReceivedThird;
                  this.itemsOnDepartament.num_processed_third =
                    response.datapi.numProcessedThird;

                  this.itemsOnDepartament.num_inmanifest_fourth =
                    response.datapi.numInmanifestFour;
                  this.itemsOnDepartament.num_insales_fourth =
                    response.datapi.numInsalesFour;
                  this.itemsOnDepartament.num_intesting_fourth =
                    response.datapi.numIntestingFour;
                  this.itemsOnDepartament.num_received_fourth =
                    response.datapi.numReceivedFour;
                  this.itemsOnDepartament.num_processed_fourth =
                    response.datapi.numProcessedFour;

                  this.itemsOnDepartament.beenInmanifest =
                    response.datapi.beenInmanifest;
                  this.itemsOnDepartament.beenInsales =
                    response.datapi.beenInsales;
                  this.itemsOnDepartament.beenIntesting =
                    response.datapi.beenIntesting;
                  this.itemsOnDepartament.beenReceived =
                    response.datapi.beenReceived;
                  $("#itemweight" + iditem).hide();

                  this.showNotification(
                    "bottom",
                    "right",
                    "success",
                    "Item deleted successfully"
                  );
                  this.getItemsWeights();
                } else {
                  this.showNotification(
                    "bottom",
                    "right",
                    "danger",
                    response.msg
                  );
                }
                this.buscando = false;
              },
              (error) => {
                console.log(<any>error);
                this.showNotification(
                  "bottom",
                  "right",
                  "danger",
                  error.statusText
                );
                this.buscando = false;
              }
            );
          }
        }.bind(this)
      );
  }

  deleteImg(idimg) {
    console.log(idimg);
    let r;
    r = confirm("Are you sure?");
    if (r === true) {
      this._imageService.deleteImage(this.token, idimg).subscribe(
        (response) => {
          if (response.status === "success") {
            $("#imgPrincipal" + idimg).hide();

            alert("done");
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    } else {
      console.log("You pressed Cancel!" + idimg);
    }
  }

  selectedFile: File;

  onFileSend(event) {
    $(".loader").show();
    $("#confirmuploadedfile").hide();
    var xhr = new XMLHttpRequest();
    this.selectedFile = <File>event.target.files[0];
    let headers = new Headers({ "Content-Type": "multipart/form-data" });

    const uploadData = new FormData();
    uploadData.append("namefile", this.selectedFile, this.selectedFile.name);
    uploadData.append("idpaciente", this.identity.sub);
    uploadData.append("idfather", this.id);
    uploadData.append("type", "FILESPROCESSING");
    console.log(uploadData);

    let met = this;

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          //  console.log(xhr.response);
          let respuesta = JSON.parse(xhr.response);
          console.log(respuesta.status);
          console.log(respuesta.img);

          if (respuesta.status == "success") {
            $(".loader").hide();
            $("#confirmuploadedfile").show();
            met.getImagesType("FILESPROCESSING");

            met.myWebSocket.next({
              notify: "1",
              data: met.id,
              type: "PI-FILE",
              token: met.token,
              action: met.identity.name + " " + met.identity.surname, // NEW ó UPDATE ó DELETE
            });

            met.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                met.numberNotifications = msg.numberNotifications;
                met.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          }
        } else {
          console.log(xhr.response);
        }
      }
    };

    xhr.open(
      "POST",
      "https://itaderp.com/backend/resources/receiver.php",
      true
    );
    //xhr.setRequestHeader('Authorization',token);
    xhr.send(uploadData);
  }

  getImagesType(type) {
    this._imageService
      .getImagesUserType(this.token, this.id, type, 0)
      .subscribe(
        (response) => {
          // console.log(response);
          if (response.status == "success") {
            this.filesCita = response.data;
          } else if (response.code == 400) {
            localStorage.clear();
            this._router.navigate(["/"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  public recived = null;
  public driver = "";
  public type = "";

  public notfound = false;

  changeWHouseStatus() {
    this.warehouseActivate = !this.warehouseActivate;
  }

  public itemsOnDepartament = {
    numInmanifest: 0,
    numInsales: 0,
    numIntesting: 0,
    numReceived: 0,
    num_processed: 0,
    num_inmanifest_second: 0,
    num_insales_second: 0,
    num_intesting_second: 0,
    num_received_second: 0,
    num_processed_second: 0,
    num_inmanifest_third: 0,
    num_insales_third: 0,
    num_intesting_third: 0,
    num_received_third: 0,
    num_processed_third: 0,
    num_inmanifest_fourth: 0,
    num_insales_fourth: 0,
    num_intesting_fourth: 0,
    num_received_fourth: 0,
    num_processed_fourth: 0,
    beenInmanifest: 0,
    beenInsales: 0,
    beenIntesting: 0,
    beenReceived: 0,
  };

  changeItemLocations(e) {
    this.itemsOnDepartament = e;
  }
  clientes2: UserList[] = [];

  private _filterClientes2(name: string): UserList[] {
    const filterValue = name.toLowerCase();
    return this.clientes2.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit() {
    this.firstFormGroup = this.fb.group({
      poNumber: ["", Validators.required],
    });

    this.item.po.id = this.poId;
    this.item.po.name = this.poNumber;
    this.manifestNew2();
    this.filteredClientes2 = this.myControlClientes2.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) =>
        name ? this._filterClientes2(name) : this.clientes2.slice()
      )
    );

    this._route.params.subscribe((params) => {
      if (params["report"]) {
        this.reportID = params["report"];
        history.pushState(null, "", "processing-instructions");
      } else if (params["ticket"]) {
        this.id = params["id"];
        this.paramTicket = true;
        //this.changeTab(11);
      } else {
        let url = document.location.href;
        if (url.includes("/note") || this.logs) {
          this.changeTab(10);
          history.pushState(null, "", "processing-instructions");
        }
      }
    });

    this.itemsOnDepartament.numInmanifest = 0;
    this.itemsOnDepartament.numInsales = 0;
    this.itemsOnDepartament.numIntesting = 0;
    this.itemsOnDepartament.numReceived = 0;
    this.itemsOnDepartament.num_processed = 0;

    this.itemsOnDepartament.num_inmanifest_second = 0;
    this.itemsOnDepartament.num_insales_second = 0;
    this.itemsOnDepartament.num_intesting_second = 0;
    this.itemsOnDepartament.num_received_second = 0;
    this.itemsOnDepartament.num_processed_second = 0;

    this.itemsOnDepartament.num_inmanifest_third = 0;
    this.itemsOnDepartament.num_insales_third = 0;
    this.itemsOnDepartament.num_intesting_third = 0;
    this.itemsOnDepartament.num_received_third = 0;
    this.itemsOnDepartament.num_processed_third = 0;

    this.itemsOnDepartament.num_inmanifest_fourth = 0;
    this.itemsOnDepartament.num_insales_fourth = 0;
    this.itemsOnDepartament.num_intesting_fourth = 0;
    this.itemsOnDepartament.num_received_fourth = 0;
    this.itemsOnDepartament.num_processed_fourth = 0;

    this.itemsOnDepartament.beenInmanifest = 0;
    this.itemsOnDepartament.beenInsales = 0;
    this.itemsOnDepartament.beenIntesting = 0;
    this.itemsOnDepartament.beenReceived = 0;

    this.item = new ProcessingInstruction(this.identity.sub);
    /*     this.item.po.id = this.poId;

    this.item.po.name = this.poNumber; */
    // if (this.data.poNumber != undefined) {
    //   this.item.po.name = this.data.poNumber;
    //   this.item.po.id = this.data.poId;
    // } else {
    //   this.item.po.id = this.poId;
    //   this.item.po.name = this.poNumber;
    // }

    if (this.action === "read") {
      console.log(this.userlogged);
      console.log(this.whs_id);

      if (this.userlogged === undefined) {
        this._userService.getUser(this.token, this.identity.sub).subscribe(
          (response) => {
            console.log(response);
            if (response.status == "success") {
              this.userlogged = response.data;

              this.apiCompany = this.userlogged.companyLinked.apiToken;
              if (this.userlogged.location == null) {
                this.userlogged.location = {};
                this.userlogged.location.id = 0;
              }

              if (this.whs_id > 0) {
                this.warehouseActivate = false;
              } else {
                this.warehouseActivate = true;
              }

              if (this.userlogged.location !== null)
                this.whs_id = this.userlogged.location.id;

              if (this.whs_id > 0) this.warehouseActivate = false;
              else this.warehouseActivate = true;
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
      } else {
        this.whs_id = this.userlogged.location.id;
        if (this.whs_id > 0) this.warehouseActivate = false;
        else this.warehouseActivate = true;
      }
      this.cargando = true;
      this._processingSerice.getOne(this.token, this.id).subscribe(
        (response) => {
          console.log(response);
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.code === 404) {
            this.notfound = true;
            history.pushState(null, "", "processing-instructions");
          } else if (response.status == "success") {
            if (
              response.data.esgReportingRequired === null ||
              !response.data.esgReportingRequired
            )
              this.esgReportingBoolean = true;
            else this.esgReportingBoolean = false;

            if (this.paramTicket && this.esgReportingBoolean === true) {
              history.pushState(null, "", "processing-instructions");
              this.changeTab(11);
            }

            console.log(response.data);
            this.manifestRep = "";
            if (response.data.manifest)
              this.manifestRep =
                response.data.manifest.name +
                " " +
                response.data.manifest.surname;
            this.testingStatusForm = response.data.testingStatus;
            this.testingStatus = response.data.testingStatus;
            this.itemsOnDepartament.numInmanifest = response.data.numInmanifest;
            this.itemsOnDepartament.numInsales = response.data.numInsales;
            this.itemsOnDepartament.numIntesting = response.data.numIntesting;
            this.itemsOnDepartament.numReceived = response.data.numReceived;
            this.itemsOnDepartament.num_processed = response.data.numProcessed;

            this.itemsOnDepartament.num_inmanifest_second =
              response.data.numInmanifestSecond;
            this.itemsOnDepartament.num_insales_second =
              response.data.numInsalesSecond;
            this.itemsOnDepartament.num_intesting_second =
              response.data.numIntestingSecond;
            this.itemsOnDepartament.num_received_second =
              response.data.numReceivedSecond;
            this.itemsOnDepartament.num_processed_second =
              response.data.numProcessedSecond;

            this.itemsOnDepartament.num_inmanifest_third =
              response.data.numInmanifestThird;
            this.itemsOnDepartament.num_insales_third =
              response.data.numInsalesThird;
            this.itemsOnDepartament.num_intesting_third =
              response.data.numIntestingThird;
            this.itemsOnDepartament.num_received_third =
              response.data.numReceivedThird;
            this.itemsOnDepartament.num_processed_third =
              response.data.numProcessedThird;

            this.itemsOnDepartament.num_inmanifest_fourth =
              response.data.numInmanifestFour;
            this.itemsOnDepartament.num_insales_fourth =
              response.data.numInsalesFour;
            this.itemsOnDepartament.num_intesting_fourth =
              response.data.numIntestingFour;
            this.itemsOnDepartament.num_received_fourth =
              response.data.numReceivedFour;
            this.itemsOnDepartament.num_processed_fourth =
              response.data.numProcessedFour;

            this.itemsOnDepartament.beenInmanifest =
              response.data.beenInmanifest;
            this.itemsOnDepartament.beenInsales = response.data.beenInsales;
            this.itemsOnDepartament.beenIntesting = response.data.beenIntesting;
            this.itemsOnDepartament.beenReceived = response.data.beenReceived;

            if (response.data.tech != null) {
              this.tech =
                response.data.tech.name + " " + response.data.tech.surname;
            } else {
              this.tech = "";
            }
            if (response.data.sales != null) {
              this.sales =
                response.data.sales.name + " " + response.data.sales.surname;
            } else {
              this.sales = "";
            }
            if (response.data.manifest != null) {
              this.manifest =
                response.data.manifest.name +
                " " +
                response.data.manifest.surname;
            } else {
              this.manifest = "";
            }
            this.recived = response.data.received;
            this.driver = response.data.driver
              ? response.data.driver.name + " " + response.data.driver.surname
              : "";
            this.getImagesType("FILESPROCESSING");
            this.getChat();
            this.getChatWeights();
            this.item.setValues(
              response.data.id, // 1
              response.data.po.id, // 2
              response.data.po.po, // 3
              response.data.account, // 4
              response.data.rep.id, // 5
              response.data.rep.name + " " + response.data.rep.surname, // 6
              this.getFecha(new Date(response.data.createdAt.timestamp * 1000)), // 7
              response.data.freightCarrier, // 8
              response.data.smallParcelCarrier, // 9
              response.data.trackingNumber, // 10
              response.data.pullHardDrives, // 11
              response.data.manifestRequired, // 12
              response.data.passDataErasure1, // 13
              response.data.passDataErasure3, // 14
              response.data.hdShredding, // 15
              response.data.hdShreddingWithReport, // 16
              response.data.holdBadHardDrives, // 17
              response.data.sendStraightToTesting, // 18
              response.data.cod, // 19
              response.data.specialNotes, // 20
              response.data.netTerms, // 21
              response.data.poPriorityLevel, // 22
              response.data.warranty, // 23
              response.data.originalTotalCostPo, // 24
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "", // 25 - 32
              response.data.manifestRequired, // 33
              "", // 34
              response.data.holdDefectiveEquipment, // 35
              response.data.sortAndSettle, // 36
              response.data.inventoryManifest, // 37
              response.data.manifestPriorityLevel, // 38
              "", // 39
              "", // 40
              0, // 41
              0, // 42
              response.data.netTerms, // 43
              response.data.descriptionTechs, // 44
              response.data.manifestStatus, // 45,
              response.data.noManifestPriorityLevel, //
              response.data.isPaid,
              response.data.clientName,
              response.data.pictureRequired,
              response.data.save_as_a_template,
              response.data.templateName,
              response.data.proNumber,
              response.data.esgReportingRequired,
              response.data.equipmentComingToWarehouse,
              response.data.sortEquipment,
              response.data.securitySealPictureRequired,
              response.data.hasTheEquipmentBeenSold,
              response.data.notesForReceiving,
              response.data.notesForManifest,
              response.data.testingReportRequired,
              response.data.notesForWiping,
              response.data.notesForSales,
              response.data.status,
              response.data.dateFirstReceived
                ? (this.dateReceived = this.mtds.getFecha(
                    new Date(response.data.dateFirstReceived.timestamp * 1000),
                    "MM-dd-yyyy"
                  ))
                : "",
              response.data.batchCompleted,
              response.data.batchTotal,
              response.data.typeReport,
              response.data.reference,

              response.data.manifestCompletedDate
                ? (this.manifestCompletedDate = this.mtds.getFecha(
                    new Date(response.data.manifestCompletedDate),
                    "MM-dd-yyyy"
                  ))
                : "",
              response.data.testingCompletedDate
                ? (this.testingCompletedDate = this.mtds.getFecha(
                    new Date(response.data.testingCompletedDate),
                    "MM-dd-yyyy"
                  ))
                : ""
            );

            this.uploadService
              .getFiles(this.token, this.item.id, "FILESPROCESSING")
              .subscribe((r2) => {
                console.log(r2);
                if (r2.code === 400 && r2.msg === "Authorization not valid") {
                  this.mtds.notifyError("Your session has expired");
                  localStorage.clear();
                  this._router.navigate(["/pages/lock"]);
                } else if (r2.status == "success") {
                  this.numFiles = r2.data.length;
                }
              });

            this.destructionclientsname = response.data.clientName;

            let status = "Paid";
            if (response.data.isPaid == 0 || response.data.isPaid == null)
              status = "Pending";

            if (
              response.data.netTerms == "SORTANDSETTLE" &&
              (response.data.isPaid == 0 || response.data.isPaid == null)
            )
              status = "S&S";
            else if (
              response.data.netTerms == "REVENUESHARE" &&
              (response.data.isPaid == 0 || response.data.isPaid == null)
            )
              status = "RS";
            this.paymentStatus = status;

            this.getTrakings();
            this.getItemsWeights();
            this.getItemsManifest();

            this.step = response.data.status;
            this._poService
              .getCita(this.token, response.data.citasId)
              .subscribe((response2) => {
                console.log("cita");
                console.log(response2);
                if (response2.status == "success") {
                  this.type = response2.data.type;
                  this.item.companyName = response2.data.companyLinked.name;
                  this.item.contactName = response2.data.contactName;
                  this.item.phoneNumber = response2.data.phone;
                  this.item.email = response2.data.address;
                  this.item.address = response2.data.address;
                  this.item.city = response2.data.city;
                  this.item.state = response2.data.state;
                  this.item.zip = response2.data.zip;
                  this.item.dataDestructionRequired =
                    response2.data.dataDestructionRequired;
                  (this.item.expectedDate = this.getFecha(
                    new Date(response2.data.expectedDate.timestamp * 1000)
                  )),
                    (this.item.all_cod = response.data.allCod);
                  this.item.totalNetWeight = response2.data.totalNetWeight;
                  this.item.shipmentQuantity = response2.data.shipmentQuantity;
                  this.item.damages = response2.data.damages;
                  this.item.net_terms = response2.data.net_terms;
                  this.citaID = response2.data.id;

                  if (
                    this.item.freightCarrier === "no data" &&
                    response2.data.truck &&
                    response2.data.truck.name
                  ) {
                    this.item.freightCarrier = response2.data.truck.name;
                  }
                }

                if (
                  this.item.freightCarrier === "no data" ||
                  this.item.freightCarrier === null
                ) {
                  this.item.freightCarrier = "";
                }
                if (
                  this.item.smallParcelCarrier === "no data" ||
                  this.item.smallParcelCarrier === null
                ) {
                  this.item.smallParcelCarrier = "";
                }
              });
            this._fileService
              .searchPO(this.privilegio.sub, this.item.po.name, this.apiCompany)
              .subscribe(
                (folderDetail) => {
                  console.log(folderDetail);
                  if (folderDetail.length === 0) {
                    this.folderId = "";
                  } else {
                    this.folderId = folderDetail[0].id;
                    //   console.log('Detalle del folder:');
                    // console.log(this.folderId);
                  }
                },
                (error) => {
                  this.folderId = "";
                }
              );

            let jsonReport;

            if (this.reportID !== null) {
              jsonReport = {
                report_id: this.reportID,
                po: this.item.po.name,
              };
            } else {
              jsonReport = {
                po: this.item.po.name,
              };
            }

            this.poReport = this.item.po.name;

            this._reportService.checkPOReport(this.token, jsonReport).subscribe(
              (response) => {
                this.typeReport = response.typeReport;

                if (this.reportID !== null) this.reports = true;
                else {
                  if (response.status === "success") {
                    this.reportID = response.data.id;
                    this.reportCompleted = response.data.completed;
                  }
                }
              },
              (error) => {
                console.log("error");
              }
            );

            this.cargando = false;
          } else {
            setTimeout(() => {
              swal.fire({
                title: "404",
                text: "PI Not found.",
                buttonsStyling: false,

                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.end();
            }, 250);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    this.iniciaReminder();

    this.filteredArrayUsers = this.myControlUsers.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterUsers(name) : this.arrayUsers.slice()))
    );
  }

  public enableUsers: boolean = false;
  showReminderUsers() {
    this.enableUsers = !this.enableUsers;
  }
  close() {
    // this.dialogRef.close();
  }

  seleccionarUser(id) {
    let numero: number, encontrado: boolean, index: number;
    index = 0;
    encontrado = false;
    for (numero of this.usersSeleccionados) {
      if (numero === id) {
        encontrado = true;
        this.usersSeleccionados.splice(index, 1);
        let json;

        json = {
          type: "DELETEUSER",
          data: numero,
        };

        /*this._notificationService.editNotification(this.token, this.editNotification, json).subscribe(
          response => {
          }
        );*/
        break;
      }
      index++;
    }

    if (!encontrado) {
      this.usersSeleccionados.push(id);
      let json;

      json = {
        type: "ADDUSER",
        data: id,
      };

      /*this._notificationService.editNotification(this.token, this.editNotification, json).subscribe(
          response => {
          }
        );*/
    }
  }

  chequeadoUser(id) {
    let numero: number;
    for (numero of this.usersSeleccionados) {
      if (numero === id) {
        return true;
      }
    }

    return false;
  }

  private _filterUsers(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.arrayUsers.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  get hasButton() {
    return this.tab == 1 || this.tab == 3 || this.tab == 2 || this.tab == 4;
  }

  getUsers() {
    this.arrayUsers = [];
    this._userService
      .getAllUsersLite(this._userService.getToken(), "exceptuser")
      .subscribe(
        (response) => {
          if (response.status === "success") {
            console.log(response);
            this.arrayUsers = response.data;
            this.usersList = response.data.map((e) => {
              return { id: e.id, name: `${e.name} ${e.surname}` };
            });
          } else {
            alert("Error");
          }
          console.log(this.arrayUsers);
        },
        (error) => {
          console.log(<any>error);
          alert("Error");
        }
      );
  }

  //SECCCIÓN TAB 9 REMINDER
  iniciaReminder() {
    this.idcontact = this.id;

    this.getAllContacts();

    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      this.addZero(today.getMonth() + 1) +
      "-" +
      this.addZero(today.getDate());
    var time =
      this.addZero(today.getHours()) +
      ":" +
      this.addZero(today.getMinutes()) +
      ":" +
      this.addZero(today.getSeconds());

    this.contacthistory = new Reminder(
      1,
      this.idcontact,
      this.identity.sub,
      "",
      "",
      date,
      time,
      "",
      "PROCESSING",
      "YES",
      0,
      0,
      "",
      ""
    );
  }

  addZero(i) {
    /*
    if (i < 10) {
      i = "0" + i;
    }*/
    //fix by atalus
    i = ("0" + i).slice(-2);
    return i;
  }

  public showhide = false;

  public reminders: DinamicData = new DinamicData([
    "Id",
    "REP",
    /*'Contact Date',*/ "Reminder Date",
    "Description",
    "Actions",
  ]);
  public loadingR = true;

  getAllContacts() {
    this.loadingR = true;
    let enviar = {
      type: "PROCESSING",
    };

    this._reminderService
      .getContactsUser(this.token, 1, this.idcontact, enviar)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            console.log(response.data);

            this.tableContacts2 = {
              headerRow: [
                "id",
                "REP",
                "Contact Date",
                "Reminder Date",
                "Description",
                "Actions",
              ],
              dataRows: [],
            };
            for (let element of response.data) {
              console.log(element);

              this.reminders.rows = [];

              let actionButtons = [
                { icon: "edit", action: "Edit", color: "warning" },
                { icon: "delete_outline", action: "Remove", color: "danger" },
              ];

              let fechaContacto = null;

              if (element.fechacontacto !== null) {
                fechaContacto = element.fechacontacto.timestamp;
              }

              for (element of response.data) {
                this.reminders.rows.push([
                  new Cell(element.id),
                  new Cell(element.rep.name),
                  // new Cell(fechaContacto * 1000, {type: 'date'}),
                  new Cell(
                    this.mtds.getFecha(
                      new Date(element.fecha.timestamp * 1000)
                    ),
                    { type: "date" }
                  ),
                  new Cell(element.descripcion),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              }
            }
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.loadingR = false;
        },
        (error) => {
          console.log(<any>error);
          this.loadingR = false;
        }
      );
  }

  actionR(e) {
    console.log(e);

    switch (e.action) {
      case "Edit": {
        console.log(e);
        this.getContactHistory(e.id);
        break;
      }
      case "Remove": {
        this.deleteContactHistory(e.id);
        break;
      }
      default:
        break;
    }
  }

  onSubmitReminder() {
    console.log("enviamos");
    console.log(this.contacthistory);
    let json;

    json = {
      users: this.usersSeleccionados,
    };
    this._reminderService
      .create(this.token, this.contacthistory, json)
      .subscribe(
        (response) => {
          console.log(response);
          this.status_contactHistory = response.status;

          if (this.status_contactHistory != "success") {
            this.status_contactHistory = "error";
          } else {
            this.showSwal("success", "Reminder has been saved!");
            this.contacthistory = response.data;
            console.log(response.data);
            //this._router.navigate(['/task', this.task.id]);
            //this.dialogRef.close();
            this.cleanContact();
            this.getAllContacts();

            return response.data;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  cleanContact() {
    let today = new Date();
    let date =
      today.getFullYear() +
      "-" +
      (this.addZero(today.getMonth()) + 1) +
      "-" +
      this.addZero(today.getDate());
    let time =
      this.addZero(today.getHours()) +
      ":" +
      this.addZero(today.getMinutes()) +
      ":" +
      this.addZero(today.getSeconds());
    this.contacthistory = new Reminder(
      1,
      this.idcontact,
      this.identity.sub,
      "",
      "",
      date,
      time,
      "",
      "PROCESSING",
      "YES",
      0,
      0,
      "",
      ""
    );
    this.editHistory = false;
  }

  getContactHistory(id) {
    this.editHistory = true;
    this._reminderService.getContact(this.token, id).subscribe((response) => {
      console.log(response);
      this.contacthistory.id = response.data.id;
      this.contacthistory.fechacontacto = this.getFecha(
        new Date(response.data.fechacontacto.timestamp * 1000)
      );
      this.contacthistory.horacontacto = response.data.horacontacto;
      this.contacthistory.reminder = response.data.reminder;
      this.contacthistory.fecha = this.getFecha(
        new Date(response.data.fecha.timestamp * 1000)
      );
      this.contacthistory.hora = response.data.hora;
      this.contacthistory.descripcion = response.data.descripcion;
      this.contacthistory.email = response.data.email;
      this.contacthistory.notification = response.data.notification;
    });
  }

  editContactHistory() {
    this.saveEditHistory = true;
    this._reminderService
      .update(this.token, this.contacthistory, this.contacthistory.id)
      .subscribe(
        (response) => {
          this.showSwal("success", "Reminder has been updated!");
          this.getAllContacts();
          this.cleanContact();
          this.saveEditHistory = false;
        },
        (error) => {
          alert(
            "Something went wrong, it was not possible to save the changes"
          );
          this.saveEditHistory = false;
        }
      );
  }

  deleteContactHistory(id) {
    swal
      .fire({
        title: "Delete Contact History",
        text: "Are you sure you want to delete this contact history",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, remove it",
      })
      .then(
        function (result) {
          if (result.value) {
            this._reminderService.deleteContact(this.token, id).subscribe(
              (response) => {
                this.showSwal("success", "Reminder has been deleted!");
                this.getAllContacts();
              },
              (error) => {
                alert("Something went wrong");
              }
            );
          }
        }.bind(this)
      );
  }

  //FIN DE SECCIÓN REMINDER

  guardarEditar(form) {
    this.guardando = true;
    let json;

    json = {
      netTerms: this.item.netTerms,
      originalTotalCostPo: this.item.originalTotalCostPo,
      warranty: this.item.warranty,
      manifestRequired: this.item.manifest,
      poPriorityLevel: this.item.poPriorityLevel,
      rep_id: this.item.buyer.id,
      hdShredding: this.item.hdShredding,
      pullHardDrives: this.item.pullHardDrives,
      holdBadHardDrives: this.item.holdBadHardDrives,
      sendStraightToTesting: this.item.sendStraightToTesting,
      holdDefectiveEquipment: this.item.holdDefectiveEquipment,
      sortAndSettle: this.item.sortAndSettle,
      inventoryManifest: this.item.inventoryManifest,
      descriptionTechs: this.item.description_techs,
      all_cod: this.item.all_cod,
      dataDestructionRequired: this.item.dataDestructionRequired,
      freightCarrier: this.item.freightCarrier,
      smallParcelCarrier: this.item.smallParcelCarrier,
      manifest_priority_level: this.item.manifest_priority_level,
      no_manifest_priority_level: this.item.no_manifest_priority_level,
      isPaid: this.item.isPaid,
      pictureRequired: this.item.pictureRequired,
      passDataErasure1: this.item.passDataErasure1,
    };

    this._processingSerice.update(this.token, this.id, json).subscribe(
      (response) => {
        if (response.status === "success") {
          this.end(form, true);
          this.showSwal("success", "Processing instructions have been saved!");

          this.myWebSocket.next({
            notify: "1",
            data: this.id,
            type: "PI",
            token: this.token,
            action: "UPDATE", // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );
        } else {
          this.showSwal("error");
        }
        this.guardando = false;
      },
      (error) => {
        this.showSwal("error");
      }
    );
  }

  changeManifest() {
    if (this.item.manifest === "No" && this.item.pullHardDrives === "No") {
      this.item.sendStraightToTesting = "Yes";
    } else {
      this.item.sendStraightToTesting = "No";
    }
  }

  invertir(option) {
    switch (option) {
      case 1:
        if (this.item.passDataErasure1 === "1X Pass") {
          this.item.passDataErasure3 = "No";
        } else if (this.item.passDataErasure1 === "3X Pass") {
          this.item.passDataErasure3 = "Yes";
        }
        break;
      case 2:
        if (this.item.passDataErasure3 === "Yes") {
          this.item.passDataErasure1 = "3X Pass";
        } else if (this.item.passDataErasure3 === "No") {
          this.item.passDataErasure1 = "1X Pass";
        }
        break;
      case 3:
        if (this.item.hdShredding === "Yes") {
          this.item.hdShreddingWithReport = "No";
        }
        // else if (this.item.hdShredding == 'No') { this.item.hdShreddingWithReport = 'Yes'; }
        break;
      case 4:
        if (this.item.hdShreddingWithReport === "Yes") {
          this.item.hdShredding = "No";
        }
        // else if (this.item.hdShreddingWithReport == 'No') { this.item.hdShredding = 'Yes'; }
        break;
      default:
        break;
    }
  }

  save(form) {
    if (this.tab !== 5) {
      this.changeTab(this.tab + 1);
    } else {
      this.guardando = true;

      // this.item.expectedDate = new Date(this.item.expectedDate);
      switch (this.action) {
        case "create":
          let cita;
          cita = {
            EndTime: "00:03",
            StartTime: "00:01",
            account: "",
            address: 'Lago Nogal Casa 14"',
            all_cod: this.item.all_cod,
            city: "zapopan",
            cod: this.item.cod,
            companyName: this.identity.companyInfo,
            company_id: 32,
            contactName: this.identity.name + " " + this.identity.surname,
            customerSignature: "",
            customerSignatureDate: "",
            dataDestructionRequired: this.item.dataDestructionRequired,
            deliverCheck: "No",
            description_techs: this.item.description_techs,
            driver_id: "4",
            email: this.identity.email,
            gondolas: 0,
            greenTekSolutionsAgent: "",
            greenTekSolutionsAgentDate: "",
            gtsRep: "",
            hdShredding: this.item.hdShredding,
            hdShreddingWithReport: this.item.hdShreddingWithReport,
            holdBadHardDrives: this.item.holdBadHardDrives,
            hold_defective_equipment: this.item.holdDefectiveEquipment,
            hora_fin: "00:00",
            id: 1,
            inventory_manifest: this.item.inventoryManifest,
            manifest: this.item.manifest,
            manifestRequired: this.item.manifest,
            manifest_priority_level: this.item.manifest_priority_level,
            no_manifest_priority_level: this.item.no_manifest_priority_level,
            isPaid: this.item.isPaid,
            net_terms: this.item.netTerms,
            numberOfHelpers: 0,
            original_total_cost_po: this.item.originalTotalCostPo,
            pallets: 0,
            passDataErasure1: this.item.passDataErasure1,
            passDataErasure3: this.item.passDataErasure3,
            phone: "",
            pickUpDate: new Date("1969-01-01"),
            pickUpTime: "00:00",
            pickupDescription: "",
            poNumber: "",
            po_id: this.item.po.id,
            po_priority_level: this.item.poPriorityLevel,
            pullHardDrives: this.item.pullHardDrives,
            rep_id: this.item.buyer.id,
            freightCarrier: this.item.freightCarrier,
            smallParcelCarrier: this.item.smallParcelCarrier,
            trackingNumber: this.item.trackingNumber,
            expectedDate: this.item.expectedDate,
            sendStraightToTesting: this.item.sendStraightToTesting,
            shrinkWrap: 0,
            sort_and_settle: this.item.sortAndSettle,
            state: "JAL",
            straps: "No",
            toolBox: "No",
            truck_id: "8",
            typeCita: "NOPICKUP",
            user_id: this.identity.sub,
            warranty: this.item.warranty,
            zip: "00000",
            frompo: this.frompo,
            pictureRequired: this.item.pictureRequired,
          };
          this._citaService.create(this.token, cita).subscribe(
            (responseCita) => {
              console.log(responseCita);
              if (responseCita.code === 200) {
                this.citaID = responseCita.data.id;

                let idPI;
                idPI = responseCita.idpi;

                this.myWebSocket.next({
                  notify: "1",
                  data: idPI,
                  type: "PI",
                  token: this.token,
                  action: "NEW", // NEW ó UPDATE ó DELETE
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );

                let data;
                data = {
                  totalNetWeight: this.item.totalNetWeight,
                  shipmentQuantity: this.item.shipmentQuantity,
                  damages: this.item.damages,
                };

                this._processingSerice
                  .weights(this.token, this.citaID, data)
                  .subscribe((response) => {
                    console.log(response);
                    if (response.status === "success") {
                      this.end(form, true);
                      this.id = response.data.id;
                      this.showSwal(
                        "success",
                        "Processing instructions have been saved!"
                      );
                    } else {
                      this.showSwal("error");
                    }
                    this.guardando = false;
                  });
              } else {
                this.guardando = false;
                this.mtds.notifyError(responseCita.msg);
              }
            },
            (error) => {
              this.guardando = false;
              this.mtds.notifyError(error.statusText);
            }
          );
          break;
        case "read":
          this.end(form, false);
          break;
        case "update":
          this._processingSerice
            .update(this.token, this.id, this.item.saveJson())
            .subscribe((response) => {
              if (response.status === "success") {
                let data;
                data = {
                  totalNetWeight: this.item.totalNetWeight,
                  shipmentQuantity: this.item.shipmentQuantity,
                  damages: this.item.damages,
                };
                this._processingSerice.weights(this.token, this.citaID, data);
                this.end(form, true);
                this.showSwal(
                  "success",
                  "Processing instructions have been updated!"
                );
                this.myWebSocket.next({
                  notify: "1",
                  data: response.data.id,
                  type: "PI",
                  token: this.token,
                  action: "UPDATE", // NEW ó UPDATE ó DELETE
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              } else {
                console.log(response);
                this.showSwal("error");
              }
              this.guardando = false;
            });
          break;
        case "delete":
          this._processingSerice
            .delete(this.token, this.id)
            .subscribe((response) => {
              if (response.status === "success") {
                this.end(form, true);
                this.showSwal(
                  "success",
                  "Processing instructions have been removed!"
                );
              } else {
                this.showSwal("error");
              }
              this.guardando = false;
            });
          break;
      }
    }
  }

  end(form = null, valor: boolean = false) {
    this.pobuscador = "";
    this.tab = 1;
    this.totalWeight = 0;
    this.comments = "";
    this.editar = false;
    if (this.poId === null && form !== null) {
      form.reset();
    }
    this.item.po.id = null;

    this.step = "INTRANSIT";
    this.item = new ProcessingInstruction(this.identity.sub);
    this.item.po.id = this.poId;
    this.item.po.name = this.poNumber;
    this.filesCita = [];
    this.itemsweights = [];
    this.tableContacts.rows = [];
    this.itemsManifest = [];
    this.itemsManifestNew = [];
    this.trakingNumber = "";
    this.expectedDate = "";
    this.sales = "";
    this.tech = "";
    this.locationsList = [];

    // this.close.emit(null);
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: "ERROR!",
        text: "An error has ocurred.",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }

  getFecha(fecha: Date) {
    let day = fecha.getDate();
    let actualDay = day < 10 ? `0${day}` : day;
    let month = fecha.getMonth() + 1;
    let actualMonth = month < 10 ? `0${month}` : month;
    let year = fecha.getFullYear();

    return actualMonth + "-" + actualDay + "-" + year;
  }

  public locktypeofequipment = false;
  public lockitemtype = false;
  public lockdamage = false;

  selectChange(campo: string) {
    switch (campo) {
      case "netTerms": {
        console.log("netTerms");
        // $("#manifest").attr('disabled', false);
        if (this.item.netTerms === "SORTANDSETTLE") {
          this.item.manifest = "Yes";
          this.item.sortAndSettle = "Yes";
          this.item.originalTotalCostPo = 0;

          // $("#manifest").attr('disabled', true);
        } else if (this.item.netTerms === "REVENUESHARE") {
          this.item.manifest = "Yes";

          // $("#manifest").attr('disabled', true);
        } else if (this.item.netTerms == "No Cost") {
          this.item.originalTotalCostPo = 0;
        }
        break;
      }
      case "manifest_priority_level": {
        console.log("manifest_priority_level");
        if (this.item.manifest_priority_level === "NOMANIFEST") {
          this.item.manifest = "No";
          this.item.manifestRequired = "No";
        } else {
          this.item.manifest = "Yes";
          this.item.manifestRequired = "Yes";
          this.item.no_manifest_priority_level = "null";
        }
        break;
      }
      case "all_cod": {
        console.log("all_cod");
        if (this.item.all_cod == "Yes") {
          this.item.cod = "No";
          this.item.hdShredding = "No";
          this.item.hdShreddingWithReport = "No";
          this.item.pullHardDrives = "No";
          // this.item.manifest = 'No';
          this.item.passDataErasure1 = "3X Pass";
          this.item.passDataErasure3 = "No";
          this.item.holdBadHardDrives = "No";
          this.item.sendStraightToTesting = "No";

          $("#passDataErasure1").append(`<option value="DESTR"> 
                                      Destruction
                                  </option>`);
          //  this.item.passDataErasure1 = 'DESTR';

          this.item.holdDefectiveEquipment = "No";
          this.item.sortAndSettle = "No";
          this.item.inventoryManifest = "yNote";
          this.item.dataDestructionRequired = "Yes";
        }
        break;
      }
      case "cod": {
        console.log("cod");
        break;
      }
      case "hdShredding": {
        console.log("hdShredding");
        if (this.item.hdShredding == "Yes") {
          // this.item.passDataErasure1 = 'No';
          // this.item.passDataErasure3 = 'No';
          this.item.pullHardDrives = "Yes";
          this.item.sendStraightToTesting = "No";
          this.item.hdShreddingWithReport = "No";
          // this.item.holdBadHardDrives = 'No';
          this.item.sendStraightToTesting = "No";
        }
        break;
      }
      case "hdShreddingWithReport": {
        console.log("hdShreddingWithReport");
        if (this.item.hdShreddingWithReport == "Yes") {
          this.item.passDataErasure1 = "3X Pass";
          this.item.passDataErasure3 = "No";
          this.item.pullHardDrives = "Yes";
          this.item.sendStraightToTesting = "No";
          this.item.hdShredding = "No";
          this.item.holdBadHardDrives = "No";
        }
        break;
      }
      case "pullHardDrives": {
        console.log("pullHardDrives");
        if (this.item.pullHardDrives == "Yes") {
          this.item.sendStraightToTesting = "No";
        }
        break;
      }
      case "manifest": {
        console.log("manifest");
        if (this.item.manifest == "Yes") {
          this.item.sendStraightToTesting = "No";
        } else if (this.item.manifest == "No") {
          //this.item.no_manifest_priority_level = 'No Manifest - 15 Days';
        }
        break;
      }
      case "passDataErasure1": {
        console.log("passDataErasure1");
        if (this.item.passDataErasure1 == "Yes") {
          this.item.passDataErasure3 = "No";
        }
        break;
      }
      case "passDataErasure3": {
        console.log("passDataErasure3");
        if (this.item.passDataErasure3 == "Yes") {
          this.item.passDataErasure1 = "3X Pass";
        }
        break;
      }
      case "holdBadHardDrives": {
        console.log("holdBadHardDrives");
        break;
      }
      case "sendStraightToTesting": {
        console.log("sendStraightToTesting");
        break;
      }
    }
  }

  public tab = 1;

  get title() {
    switch (this.tab) {
      case 1:
        this.titleModal = "PO Details";
        break;
      case 2:
        this.titleModal = "Transportation Details";
        break;
      case 3:
        this.titleModal = "Receiving Processing Instructions";
        break;
      case 4:
        this.titleModal = "Manifesting Processing Instructions";
        break;
      case 5:
        this.titleModal = "Testing Processing Instructions";
        break;
      case 6:
        this.titleModal = "Data Sanitization";
        break;
      case 7:
        this.titleModal = "Sales Processing Instructions";
        break;
      case 8:
        this.titleModal = "Set Weights";
        break;
      case 9:
        this.titleModal = "Files";
        break;
      case 10:
        this.titleModal = "Notes";
        break;
      case 11:
        this.titleModal = "Tickets";
        break;
      case 12:
        this.titleModal = "Reminders";
        break;
      default:
        this.titleModal = "PO Details";
    }
    return this.titleModal;
  }

  changeTab(tab) {
    this.closeItem();
    this.endTraking();
    this.tab = tab;
    $(".noticket").show();
  }

  sumarPeso() {
    switch (this.itemtype) {
      case "Box":
        this.totalNetWeight = this.totalWeight - 2;
        break;
      case "Gondola":
        this.totalNetWeight = this.totalWeight - 32;
        break;
      case "Gaylord":
        this.totalNetWeight = this.totalWeight - 70;
        break;
      case "Pallet":
        this.totalNetWeight = this.totalWeight - 45;
        break;
      case "H-Dolly":
        this.totalNetWeight = this.totalWeight - 18;
        break;
      case "Rack":
        this.totalNetWeight = this.totalWeight - 0;
        break;
      case "Standalone":
        this.totalNetWeight = this.totalWeight - 0;
        break;
      default:
        this.totalNetWeight = this.totalWeight - 0;
    }

    this.getLocations();
  }

  public itemShow = false;
  public saving = false;
  public itemEditar;
  public itemIdLocationEditar;

  updatelocation() {
    $("#donelocation").hide();
    $("#errordonelocation").hide();

    console.log(this.location_id);
    console.log(this.itemEditar);

    let enviar = {
      po_id: this.item.po.id,
      item: this.itemtype,
      weight: this.totalWeight,
      totalNetWeight: this.totalNetWeight,
      damages: this.damages,
      comments: this.comments,
      internallocation_id: this.location_id,
      is_pi: this.itemIsPi,
      typeEquipment: this.typeofe,
    };

    this._weightItemService
      .changelocation(this.token, enviar, this.itemEditar)
      .subscribe(
        (response) => {
          this.saving = false;
          console.log(response);
          if (response.status === "success") {
            $("#donelocation").show();
          } else {
            $("#errordonelocation").show();
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          console.log(<any>error);
          alert("error");
        }
      );
  }

  procesados() {
    if (
      (this.step === "PICKEDUP" || this.step === "INTRANSIT") &&
      this.action !== "create"
    ) {
      return false;
    }
    if (
      this.itemsOnDepartament.numInsales > 0 ||
      this.itemsOnDepartament.numIntesting > 0 ||
      this.itemsOnDepartament.numInmanifest > 0 ||
      this.itemsOnDepartament.numReceived > 0 ||
      this.itemsOnDepartament.num_insales_second > 0 ||
      this.itemsOnDepartament.num_intesting_second > 0 ||
      this.itemsOnDepartament.num_inmanifest_second > 0 ||
      this.itemsOnDepartament.num_received_second > 0 ||
      this.itemsOnDepartament.num_inmanifest_third > 0 ||
      this.itemsOnDepartament.num_insales_third > 0 ||
      this.itemsOnDepartament.num_intesting_third > 0 ||
      this.itemsOnDepartament.num_received_third > 0 ||
      this.itemsOnDepartament.num_inmanifest_fourth > 0 ||
      this.itemsOnDepartament.num_insales_fourth > 0 ||
      this.itemsOnDepartament.num_intesting_fourth > 0 ||
      this.itemsOnDepartament.num_received_fourth > 0
    ) {
      return false;
    }

    return true;
  }

  firstProcesados(): boolean {
    return (
      this.itemsOnDepartament.numInsales === 0 &&
      this.itemsOnDepartament.numIntesting === 0 &&
      this.itemsOnDepartament.numInmanifest === 0 &&
      this.itemsOnDepartament.numReceived === 0 &&
      this.step !== "INTRANSIT"
    );
  }

  public location_name = "";

  showItem(row) {
    console.log(row);
    // this.location_id = null;
    this.itemEditar = row.id;
    this.location_id = row.internalLocation.id;
    this.location_name =
      row.internalLocation.locationName +
      ": " +
      row.internalLocation.locationRow +
      " - " +
      row.internalLocation.locationBay +
      " - " +
      row.internalLocation.locationLevel +
      " - " +
      row.internalLocation.locationSection;
    this.itemShow = true;
    this.itemtype = row.item;
    this.totalWeight = row.weight;
    this.totalNetWeight = row.totalNetWeight;
    this.damages = row.damages;
    this.comments = row.comments;
    this.typeofe = row.typeEquipment !== null ? row.typeEquipment : "";
    this.ispending = row.pending;
    /*
    if (row.isPi == 0) this.itemIsPi = "2nd";
    else if (row.isPi == 1) this.itemIsPi = "1st";
    else if (row.isPi == 3) this.itemIsPi = "3rd";
    else if (row.isPi == 4) this.itemIsPi = "4th";
    this.itemIsPi = this.itemIsPi.replace(/\D/g, "");
    if (row.isPi == 2) this.itemIsPi = 0;
*/

    this.itemIsPi = row.isPi;

    // this.getLocations();
    this.getChatWeights();

    let json;
    json = {
      item: this.itemtype,
      totalNetWeight: this.totalWeight,
    };
    if (this.location_id === "") {
      this.location_id = null;
    }

    console.log(this.location_id);
    console.log(this.whs_id);
    this.loadingLocations = true;
    if (this.whs_id != null)
      this._locationService
        .getAvailables(this.token, this.whs_id, json)
        .subscribe(
          (response) => {
            this.saving = false;
            console.log(response);
            if (response.status === "success") {
              let flat = false;
              this.locationsList = [];
              for (let item of response.data) {
                let location = {
                  id: item.id,
                  name:
                    item.locationName +
                    ": " +
                    item.locationRow +
                    "-" +
                    item.locationBay +
                    "-" +
                    item.locationLevel +
                    "-" +
                    item.locationSection,
                };
                this.locationsList.push(location);
                if (this.location_id === item.id) {
                  flat = true;
                }
              }

              if (
                !flat &&
                this.location_id !== null &&
                this.location_id !== ""
              ) {
                let location = {
                  id: this.location_id,
                  name: this.location_name,
                };
                this.locationsList.push(location);
              }
            } else {
              this.showWarehouseError = true;
            }
            this.loadingLocations = false;
          },
          (error) => {
            this.loadingLocations = false;
            console.log(<any>error);
            alert("error");
          }
        );
  }

  closeItem() {
    this.itemShow = false;
    this.itemtype = "";
    this.totalWeight = 0;
    this.totalNetWeight = 0;
    this.damages = "";
    this.comments = "";
    this.location_id = null;
    //this.whs_id = null;
    $("#donelocation").hide();
    $("#errordonelocation").hide();
    this.getItemsWeights();
  }

  print(element) {
    window.open(
      "https://www.itaderp.com/backend/reports/weight-labels.php?idweight=" +
        element.id +
        "&batch=" +
        element.num +
        "&apikey=" +
        this.apikey
    );
  }

  printItemManifest(id) {
    console.log(id);
    window.open(
      "https://www.itaderp.com/backend/reports/wipe-room-form.php?id=" +
        id.id +
        "&batch=" +
        id.batch +
        "&apikey=" +
        this.apikey
    );
  }

  public newManifest = false;
  public newManifest2 = false;
  public newManifest2_1step = false;
  public newManifest2_2step = false;
  public newManifest2_3step = false;
  public newManifest2_step = 1;
  public splitManifest = false;
  public newContainerType = "";
  public newContentType = "";
  public caddies = "";
  public batchPriorityLevel = "";
  public newcontainerWeight = 0;
  public newcontainerTotalNetWeight = 0;
  public loadingLocationsNewContainer = false;
  public locationsListNewContainer = [];
  public newcontainerInternallocation_id = 0;
  public newcontainerNameInternal = "";
  public newcontainerLinkTo = "";
  public containers_newmanifest = [];
  public ssd = 0;
  public ssdDone = 0;
  public ssdSplit = 0;
  public itemsManifestNew: any[];
  public errorSsd: boolean = false;
  public item_split_status = "";
  public status_container_type = "";
  public idmanifestSelected: any;

  public containersType = [
    { name: "Box", icon: "/assets/img/batch/box.svg" },
    { name: "Gaylord", icon: "/assets/img/batch/gaylord.svg" },
    { name: "Gondola", icon: "/assets/img/batch/gondola.svg" },
    { name: "HDolly", icon: "/assets/img/batch/hdolly.svg" },
    { name: "Pallet", icon: "/assets/img/batch/pallet.svg" },
    { name: "Rack", icon: "/assets/img/batch/rack.svg" },
    { name: "Standalone", icon: "/assets/img/batch/standalone.svg" },
  ];

  public contentType = [
    { name: "Devices", icon: "/assets/img/batch/devices.svg" },
    { name: "HDD/SSD", icon: "/assets/img/batch/hdd-ssd.svg" },
    { name: "Mobile Devices", icon: "/assets/img/batch/mobiledevices.svg" },
  ];

  receive_chatitem_id(valor) {
    //recibimos valor id del CID creado desde el app-comment
    console.log("receive_chatitem_id => ", valor);
    this.itemManifestID = valor;
  }

  closeManifest2() {
    this.newManifest = false;
    this.caddies = "";
    this.batchPriorityLevel = "";
    this.loadingLocationsNewContainer = false;
    this.newManifest2 = false;
    this.newManifest2_1step = false;
    this.newManifest2_2step = false;
    this.newManifest2_3step = false;
    this.newcontainerWeight = 0;
    this.containers_newmanifest = [];
    this.locationsListNewContainer = [];
    this.ssd = 0;
    this.close();
  }
  public errorHdShredding: boolean = false;
  changeStep() {
    console.log("se hizo");
    this.newManifest2_step = 2;

    this.errorHdShredding = false;

    this._processingSerice.getOne(this.token, this.item.po.id).subscribe(
      (response) => {
        if (response.status === "success") {
          if (response.data.hdShredding === "No") this.errorHdShredding = true;
          else this.stepper.next();
        } else {
          alert("Error, something went wrong");
        }
      },

      (error) => {
        console.log(<any>error);
      }
    );
  }

  confirmDeleteBatch(item) {
    let response = confirm("Are you sure you want to delete this batch?");

    if (response) {
      this.deletManiest_id = item.id;
      this.deleteManifest();
    }
  }
  showToast(type, title, timer) {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = swal.stopTimer;
        toast.onmouseleave = swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: type,
      title: title,
    });
  }
  saveManifestNew() {
    let data: any;
    data = {
      ssd: this.ssd,
      hardDrives: this.hardDrives,
      mobileDevices: this.mobileDevices,
      laptops: this.laptops,
      containers: this.containers,
      processing_instruction_id: this.piId,
      containersmdl: this.containersmdl,
      allInOne: this.allInOne,
      desktops: this.desktops,
      batchPriorityLevel: this.batchPriorityLevel,
      containersDevices: this.containersDevices,
      internallocation_id: this.newcontainerInternallocation_id,
      newcontainerTotalNetWeight: this.newcontainerTotalNetWeight,
      status: "Pending",
      weight: this.newcontainerWeight,
      caddies: this.caddies,
      newContentType: this.newContentType,
      newContainerType: this.newContainerType,
      assignTo: this.assignTo,
    };

    // if (this.itemManifestID === null) {
    //   this._processingSerice
    //     .newItemManifest(this.token, data)
    //     .subscribe((response) => {
    //       if (response.status === "success") {
    //         let batch;

    //         batch = response.data.batch;

    //         this.getItemsManifest();
    //         this.closeManifest2();
    //       }
    //     });
    // } else {
    //   this._processingSerice
    //     .editItemManifest(this.token, this.itemManifestID, data)
    //     .subscribe((response) => {
    //       if (response.status === "success") {
    //         this.getItemsManifest();
    //         this.closeManifest2();
    //       }
    //     });
    // }
    this.batchCreated.emit(data);
  }

  manifestNew() {
    /*if (this.itemsManifest.length < 3) {
      this.newManifest = true;
    }*/
    this.closeManifest();
    this.newManifest = true;
  }

  changestatusmanifest(item, status) {
    console.log("item =>", item);
    console.log("status =>", status);

    this._processingSerice
      .changestatusmanifest(this.token, item.id, { status: status })
      .subscribe((response) => {
        if (response.code == 200 && response.status == "success") {
          item.status = status;
        }
      });
  }

  showCommentsBatch(id) {
    $("#commentbox-" + id).toggle();
  }

  unlocklocation(item) {
    console.log("item => ", item);
    this.getLocationsContainerToEdit(item);

    $("#locationinput-" + item.id).hide();
    $("#locationselect-" + item.id).show();
  }

  locklocation(id) {
    console.log("locklocation fired");
    $("#locationinput-" + id).show();
    $("#locationselect-" + id).hide();
  }

  manifestNew2() {
    this._containerService.showAll().subscribe((response) => {
      if (response.code === 200) {
        this.containers_newmanifest = response.data;
        console.log("containers_newmanifest =>", this.containers_newmanifest);
      }
    });

    this.idmanifestSelected = null;
    this.caddies = "";
    this.batchPriorityLevel = "";
    this.ssd = 0;
    this.loadingLocationsNewContainer = false;
    this.closeManifest();
    this.newManifest2_step = 1;
    // this.newManifest2_1step = true;
    // this.newManifest2_2step = false;
    // this.newManifest2_3step = false;
    this.newcontainerWeight = 0;
    this.containers_newmanifest = [];
    this.locationsListNewContainer = [];
  }

  selectContainerType(value) {
    this.stepper.next();
    this.statusContainer = value;
    this.newContainerType = value;
    console.log("this.newContainerType  selected => ", this.newContainerType);
    this.newManifest2_step = 3;
    // this.newManifest2_1step = false;
    // this.newManifest2_2step = true;
    // this.newManifest2_3step = false;
  }

  selectContentType(value) {
    this.stepper.next();
    this.statusContent = value;
    this.newContentType = value;

    console.log("this.newContentType  selected => ", this.newContentType);
    this.newManifest2_step = 4;

    // this.newManifest2_1step = false;
    // this.newManifest2_2step = false;
    // this.newManifest2_3step = true;
  }

  changecaddies(value) {
    console.log("changecaddies => ", value);
  }

  sumarPesoNewContainer() {
    let restar = 0;
    let me = this;
    const filtered = this.containers_newmanifest.filter(function (element) {
      return element.name === me.newContainerType;
    });

    console.log("filtered => ", filtered);

    if (filtered) restar = filtered[0].tare;

    switch (me.newContainerType) {
      case "Box":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "Gondola":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "Gaylord":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "Pallet":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "H-Dolly":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "HDolly":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "Rack":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      case "Standalone":
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
        break;
      default:
        this.newcontainerTotalNetWeight =
          Number(this.newcontainerWeight) - Number(restar);
    }

    this.getLocationsNewContainer();
  }

  getLocationsNewContainer() {
    this.locationsListNewContainer = [];
    let po = "";
    // if (this.data.poNumber != undefined) {
    //   po = this.data.poNumber;
    // } else {
    po = this.poNumber;
    // }
    this.loadingLocationsNewContainer = true;
    let json;
    json = {
      item: this.newContainerType,
      totalNetWeight: this.newcontainerTotalNetWeight,
      po: po,
      showAllLocations: this.showAllLocations,
    };

    this._locationService
      .getAvailables(this.token, this.whs_id, json)
      .subscribe(
        (response) => {
          this.loadingLocationsNewContainer = false;
          console.log(response);
          if (response.status === "success") {
            this.locationsListNewContainer = response.data.map((item) => {
              return {
                id: item.id,
                name: `${item.location.name} - ${item.locationName}: ${item.locationRow}-${item.locationBay}-${item.locationLevel}-${item.locationSection}`,
                linkTo: item.linkTo,
              };
            });

            const flat = this.locationsListNewContainer.find(
              (item) => item.id === this.newcontainerInternallocation_id
            );

            if (!flat && this.newcontainerInternallocation_id !== null) {
              const location = {
                id: this.newcontainerInternallocation_id,
                name: this.newcontainerNameInternal,
                linkTo: this.newcontainerLinkTo,
              };
              this.locationsListNewContainer.push(location);
            }
          }
          this.loading = false;
        },
        (error) => {
          this.loadingLocationsNewContainer = false;
          console.log(<any>error);
          // this.showSwal('error');
        }
      );
  }

  getLocationsContainerToEdit(item) {
    this.locationsListNewContainer = [];

    this.loadingLocationsNewContainer = true;
    let json;
    json = {
      item: item.typeOfContent,
      totalNetWeight: item.weight,
      showAllLocations: this.showAllLocations,
    };

    this._locationService
      .getAvailables(this.token, this.whs_id, json)
      .subscribe(
        (response) => {
          this.loadingLocationsNewContainer = false;
          console.log(response);
          if (response.status === "success") {
            this.locationsListNewContainer = response.data.map((item) => {
              return {
                id: item.id,
                name: `${item.location.name} - ${item.locationName}: ${item.locationRow}-${item.locationBay}-${item.locationLevel}-${item.locationSection}`,
                linkTo: item.linkTo,
              };
            });

            const flat = this.locationsListNewContainer.find(
              (item) => item.id === this.newcontainerInternallocation_id
            );

            if (!flat && this.newcontainerInternallocation_id !== null) {
              const location = {
                id: this.newcontainerInternallocation_id,
                name: this.newcontainerNameInternal,
                linkTo: this.newcontainerLinkTo,
              };
              this.locationsListNewContainer.push(location);
            }
          }
          this.loading = false;
        },
        (error) => {
          this.loadingLocationsNewContainer = false;
          console.log(<any>error);
          // this.showSwal('error');
        }
      );
  }

  changeLocationNewContainer(location) {
    this.newcontainerInternallocation_id = location.id;
    this.newcontainerNameInternal = location.name;
    this.newcontainerLinkTo = location.linkTo;
  }

  changeLocationEditContainer(location, item) {
    console.log("changeLocationEditContainer location => ", location);
    console.log("changeLocationEditContainer item => ", item);

    this._processingSerice
      .changeLocationManifest(this.token, item.id, { id_location: location.id })
      .subscribe((response) => {
        console.log("changeLocationEditContainer response => ", response);
        if (response.status === "success") {
          item.internalLocation = response.data.internalLocation;
          this.locklocation(item.id);
        }
      });
  }

  public erasure: boolean = false;
  public typeErasure: string = "";
  public question: string = "";
  public erasureItem: any = null;
  public savingErasure = false;

  public manifestFinish = false;
  public finishedBashed = false;

  cambiarestatus(nuevoStatus) {
    // this.finished(nuevoStatus, );
    switch (nuevoStatus) {
      case "INTESTING":
        this.finished("INTESTING", this.item.id, 1, this.step === "INMANIFEST");
        break;
      case "INSALES":
        this.finished("INSALES", this.item.id, 1, this.step === "INTESTING");
        break;
      case "PROCESSED":
        this.finished("PROCESSED", this.item.id, 1, this.step === "INSALES");
        break;
      default:
        break;
    }
  }

  log(item) {
    console.log(item);
  }

  finished(typeErasure: string, item, fin = 1, bool = false) {
    if (fin === null || bool) {
      this.erasure = true;
      this.typeErasure = typeErasure;
      this.erasureItem = item;

      if (this.typeErasure === "HARDDRIVES") {
        this.question = "Have you completed the erasure of all hard drives?";
      } else if (this.typeErasure === "MOBILEDEVICES") {
        this.question = "Have you completed the erasure of all mobile devices?";
      } else if (this.typeErasure === "LAPTOPS") {
        this.question = "Have you completed the erasure of all laptops?";
      } else if (this.typeErasure === "DESKTOPS") {
        this.question = "Have you completed the erasure of desktops?";
      } else if (this.typeErasure === "ALLINONE") {
        this.question = "Have you completed the erasure of AIO?";
      } else if (this.typeErasure === "INTESTING") {
        this.question = "Have you completed the manifest?";
      } else if (this.typeErasure === "INSALES") {
        this.question = "Have you tested all the equipment?";
      } else if (this.typeErasure === "CONTAINERS") {
        this.question = "How many HDD containers have you processed?";
      } else if (this.typeErasure === "CONTAINERSDEVICES") {
        this.question = "How many containers for devices have you processed?";
      } else if (this.typeErasure === "PROCESSED") {
        console.log(this.itemsManifest);
        this.manifestFinish = true;
        for (item of this.itemsManifest) {
          if (
            item.hardDrivesDone !== 1 ||
            item.laptopsDone !== 1 ||
            item.allinoneDone !== 1 ||
            item.desktopsDone !== 1
          ) {
            this.manifestFinish = false;
          }
        }

        if (this.manifestFinish) {
          this.question = "Have you processed all the equipment?";
        } else {
          this.question =
            "You can't mark this PO as completed because there are other things pending to be process.";
        }
      }
    }
  }

  closeErasure() {
    this.typeErasure = "";
    this.erasureItem = null;
    this.question = "";
    this.erasure = false;
    this.errorContainers = false;
    this.containersProcessed = 0;
    this.finishedBashed = false;
  }

  saveContainers() {
    this.savingErasure = true;
    let enviar = {
      typeItem: this.typeErasure,
      container: this.containersProcessed,
    };

    if (
      this.typeErasure === "CONTAINERS" ||
      this.typeErasure === "CONTAINERSDEVICES"
    ) {
      this._processingSerice
        .setContainersDone(this.token, this.erasureItem, enviar)
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status == "success") {
              this.getItemsManifest();
              this.closeErasure();
            } else if (
              response.status == "error" &&
              response.data == "greater"
            ) {
              this.errorContainers = true;
            } else {
              alert("Error");
            }
            this.savingErasure = true;
          },
          (error) => {
            alert("Error");
            this.savingErasure = true;
          }
        );
    }
  }

  setDone() {
    //console.log("entra a set done");
    this.finishedBashed = true;
    console.log(this.id);
    this.savingErasure = true;
    let enviar = {
      typeItem: this.typeErasure,
    };

    if (
      this.typeErasure === "HARDDRIVES" ||
      this.typeErasure === "MOBILEDEVICES" ||
      this.typeErasure === "LAPTOPS" ||
      this.typeErasure === "DESKTOPS" ||
      this.typeErasure === "ALLINONE"
    ) {
      this._processingSerice
        .setmanifestdone(this.token, this.erasureItem, enviar)
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status == "success") {
              //console.log("entra");

              let batch;

              batch = response.data.batch;

              if (this.typeErasure === "HARDDRIVES") {
                this.myWebSocket.next({
                  notify: "1",
                  data: this.id,
                  type: "HD-PI-DONE",
                  token: this.token,
                  action: "NEW", // NEW ó UPDATE ó DELETE
                  extra: batch,
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              }

              if (this.typeErasure === "LAPTOPS") {
                this.myWebSocket.next({
                  notify: "1",
                  data: this.id,
                  type: "LP-PI-DONE",
                  token: this.token,
                  action: "NEW", // NEW ó UPDATE ó DELETE
                  extra: batch,
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              }

              if (this.typeErasure === "ALLINONE") {
                console.log("Notificación All In One Done");
                this.myWebSocket.next({
                  notify: "1",
                  data: this.id,
                  type: "ALL-PI-DONE",
                  token: this.token,
                  action: "NEW", // NEW ó UPDATE ó DELETE
                  batch: batch,
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              }

              if (this.typeErasure === "DESKTOPS") {
                this.myWebSocket.next({
                  notify: "1",
                  data: this.id,
                  type: "DK-PI-DONE",
                  token: this.token,
                  action: "NEW", // NEW ó UPDATE ó DELETE
                  extra: batch,
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              }

              if (response.done == 1) {
                this.myWebSocket.next({
                  notify: "1",
                  data: this.id,
                  type: "MANIFEST-DONE-PI",
                  token: this.token,
                  action: "NEW", // NEW ó UPDATE ó DELETE
                  extra: batch,
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              }

              this.getItemsManifest();
              this.closeErasure();
            } else {
              alert("Error");
            }
            this.savingErasure = true;
          },
          (error) => {
            alert("Error");
            this.savingErasure = true;
          }
        );
    } else {
      this._processingSerice
        .updateStatus(this.token, this.item.id, this.typeErasure)
        .subscribe(
          (response) => {
            if (response.status == "success") {
              if (this.step == "INMANIFEST") {
                this.step = "INTESTING";
              } else if (this.step == "INTESTING") {
                this.step = "INSALES";
              } else if (this.step == "INSALES") {
                this.step = "PROCESSED";
              }

              if (this.step != "PROCESSED") {
                this.myWebSocket.next({
                  notify: "1",
                  data: this.item.id,
                  type: "PI-STATUS",
                  token: this.token,
                  action: this.step, // NEW ó UPDATE ó DELETE
                });

                this.myWebSocket.asObservable().subscribe(
                  (msg) => {
                    let msgCoded;
                    msgCoded = JSON.stringify(msg);
                    console.log("message received: " + msgCoded);
                    this.numberNotifications = msg.numberNotifications;
                    this.notificationsData = msg.data;
                  },
                  // Called whenever there is a message from the server
                  (err) => console.log(err),
                  // Called if WebSocket API signals some kind of error
                  () => console.log("complete")
                  // Called when connection is closed (for whatever reason)
                );
              }
            } else {
              alert("Error");
            }
            this.savingErasure = true;
          },
          (error) => {
            alert("Error");
            this.savingErasure = true;
          }
        );
      this.closeErasure();
    }
  }

  public itemsManifest: any[];
  public total_manifest_pages = 0;
  public total_manifest_count_pages = 0;
  public total_manifest_perpage = 4;
  public manifest_count_actual_page = 1;
  public pages = [];
  public page = 1;
  public filtroMI = "ALL";
  public granTotalMI = 0;

  goPrevMI(event) {
    event.preventDefault();
    this.getItemsManifest(
      this.manifest_count_actual_page - 1,
      this.total_manifest_perpage
    );
  }

  goNextMI(event) {
    event.preventDefault();
    if (this.manifest_count_actual_page == this.total_manifest_pages)
      return false;

    this.getItemsManifest(
      this.manifest_count_actual_page + 1,
      this.total_manifest_perpage
    );
  }

  gotoPageMI(event, page) {
    event.preventDefault();
    console.log("gotoPageMI => ", page);
    this.getItemsManifest(page, this.total_manifest_perpage);
  }

  filtrarMI(changeto) {
    this.filtroMI = changeto;
    this.getItemsManifest();
  }

  getItemsManifest(page = 1, perpage = 4) {
    this.cargandoBatch = true;
    this._processingSerice
      .getItemsManifest(this.token, this.id, page, perpage, this.filtroMI)
      .subscribe((response) => {
        this.total_manifest_pages = response.total_pages;
        this.total_manifest_count_pages = response.total_items_count;
        this.manifest_count_actual_page = response.page_actual;
        this.total_manifest_perpage = response.items_per_page;
        this.granTotalMI = response.gran_total;
        this.itemsManifest = [];
        this.itemsManifestNew = [];

        this.cant_pending = response.cant_pending;
        this.cant_in_progress = response.cant_in_progress;
        this.cant_completed = response.cant_completed;

        let valorfor = this.page - 2;
        if (valorfor < 0) {
          valorfor = 0;
        }
        this.pages = [];
        let cont = 0;
        for (let i = valorfor; i < this.total_manifest_pages; i++) {
          let vaalortest = this.page - i;
          // console.log(vaalortest);
          this.pages.push(i);
          cont++;
          if (cont > 10) {
            break;
          }
        }

        // console.log('Items Manifest:');
        let contarElement = 1;
        for (let item of response.data) {
          let desktopsDoneInterno = 0;
          if (item.desktops > 0) desktopsDoneInterno = item.desktopsDone;
          else desktopsDoneInterno = 1;

          let allinoneDoneInterno = 0;
          if (item.allInOne > 0) allinoneDoneInterno = item.allinoneDone;
          else allinoneDoneInterno = 1;

          let hardDrivesDoneInterno = 0;
          if (item.hardDrives > 0) hardDrivesDoneInterno = item.hardDrivesDone;
          else hardDrivesDoneInterno = 1;

          let mobileDevicesDoneInterno = 0;
          if (item.mobileDevices > 0)
            mobileDevicesDoneInterno = item.mobileDevicesDone;
          else mobileDevicesDoneInterno = 1;

          let laptopsDoneInterno = 0;
          if (item.laptops > 0) laptopsDoneInterno = item.laptopsDone;
          else laptopsDoneInterno = 1;

          let containersDoneInterno = 0;
          if (item.containers > 0) containersDoneInterno = item.containersDone;
          else containersDoneInterno = 1;

          let containersDevicesDoneInterno = 0;
          if (item.containersDevices > 0)
            containersDevicesDoneInterno = item.containersDevicesDone;
          else containersDevicesDoneInterno = 1;

          let objeto = {
            id: item.id,
            hardDrives: item.hardDrives,
            hardDrivesDone: hardDrivesDoneInterno,
            mobileDevices: item.mobileDevices,
            mobileDevicesDone: mobileDevicesDoneInterno,
            laptops: item.laptops,
            laptopsDone: laptopsDoneInterno,
            containers: item.containers,
            containersDone: containersDoneInterno,
            desktops: item.desktops,
            desktopsDone: desktopsDoneInterno,
            allInOne: item.allInOne,
            allinoneDone: allinoneDoneInterno,
            //contarElement: contarElement,
            batch: item.batch,
            dosplit: false,
            containersmdl: item.containersmdl,
            containersDevices: item.containersDevices,
            containersDevicesDone: containersDevicesDoneInterno,
            repNameBatchDone: item.repNameBatchDone,
            repNameHardDrives: item.repNameHardDrives,
            repNameLaptops: item.repNameLaptops,
            repNameAllInOne: item.repNameAllInOne,
            repNameDesktops: item.repNameDesktops,
            status: item.status,
            caddies: item.caddies,
            batchPriorityLevel: item.batchPriorityLevel,
            containerType: item.containerType,
            internalLocation: item.internalLocation,
            ssd: item.ssd,
            ssdDone: item.ssdDone,
            typeOfContent: item.typeOfContent,
            weight: item.weight,
            processingInstruction: item.processingInstruction,
          };

          if (item.status && item.status.length > 2)
            this.itemsManifestNew.push(objeto);
          else this.itemsManifest.push(objeto);
          contarElement++;
        }
        //console.log("this.itemsManifest => ", this.itemsManifest);
        //console.log("this.itemsManifestNew => ", this.itemsManifestNew);
        this.cargandoBatch = false;
      });
  }

  public itemManifestID = null;
  public hardDrives = 0;
  public mobileDevices = 0;
  public laptops = 0;
  public containers = 0;
  public containersmdl = 0;
  public desktops = 0;
  public allInOne = 0;
  public containersDevices = 0;

  public hardDrivesSplit = 0;
  public hardDrivesDone = 0;
  public laptopsSplit = 0;
  public laptopsDone = 0;
  public containersSplit = 0;
  public desktopsSplit = 0;
  public desktopsDone = 0;
  public allInOneSplit = 0;
  public allInOneDone = 0;
  public containersDevicesSplit = 0;
  public saveSplit: boolean = false;
  public saveManifestB: boolean = false;

  saveSplitManifest() {
    this.errorHardDrives = false;
    this.errorAllInOne = false;
    this.errorDesktops = false;
    this.errorLaptops = false;
    this.errorSsd = false;

    this.saveSplit = true;

    let granted = true;

    if (this.item_split_status && this.item_split_status.length > 2) {
      if (this.status_container_type == "HDD/SSD") {
        if (this.hardDrivesDone === 0 || this.hardDrivesDone === null) {
          this.hardDrivesDone = 0;

          console.log(this.hardDrives - this.hardDrivesSplit);
          if (Number(this.hardDrives) - Number(this.hardDrivesSplit) < 0)
            this.errorHardDrives = true;
        }

        if (this.ssdDone === 0 || this.ssdDone === null) {
          this.ssdDone = 0;
          if (Number(this.ssd) - Number(this.ssdSplit) < 0)
            this.errorSsd = true;
        }

        if (this.errorHardDrives || this.errorSsd) granted = false;
      }

      if (this.status_container_type != "HDD/SSD") {
        if (this.laptopsDone === 0 || this.laptopsDone === null) {
          this.laptopsDone = 0;
          if (Number(this.laptops) - Number(this.laptopsSplit) < 0)
            this.errorLaptops = true;
        }

        if (this.desktopsDone === 0 || this.desktopsDone === null) {
          this.desktopsDone = 0;
          if (Number(this.desktops) - Number(this.desktopsSplit) < 0)
            this.errorDesktops = true;
        }
        if (this.allInOneDone === 0 || this.allInOneDone === null) {
          this.allInOneDone = 0;
          if (Number(this.allInOne) - Number(this.allInOneSplit) < 0)
            this.errorAllInOne = true;
        }

        if (this.errorLaptops || this.errorDesktops || this.errorAllInOne)
          granted = false;
      }
    } else {
      if (this.hardDrivesDone === 0 || this.hardDrivesDone === null) {
        this.hardDrivesDone = 0;
        if (Number(this.hardDrives) - Number(this.hardDrivesSplit) < 0)
          this.errorHardDrives = true;
      }

      if (this.ssdDone === 0 || this.ssdDone === null) {
        this.ssdDone = 0;
        if (Number(this.ssd) - Number(this.ssdSplit) < 0) this.errorSsd = true;
      }

      if (this.laptopsDone === 0 || this.laptopsDone === null) {
        this.laptopsDone = 0;
        if (Number(this.laptops) - Number(this.laptopsSplit) < 0)
          this.errorLaptops = true;
      }

      if (this.desktopsDone === 0 || this.desktopsDone === null) {
        this.desktopsDone = 0;
        if (Number(this.desktops) - Number(this.desktopsSplit) < 0)
          this.errorDesktops = true;
      }
      if (this.allInOneDone === 0 || this.allInOneDone === null) {
        this.allInOneDone = 0;
        if (Number(this.allInOne) - Number(this.allInOneSplit) < 0)
          this.errorAllInOne = true;
      }

      if (
        this.errorLaptops ||
        this.errorDesktops ||
        this.errorAllInOne ||
        this.errorSsd
      )
        granted = false;
    }

    if (granted) {
      let data: any;
      data = {
        hardDrivesSplit: this.hardDrivesSplit,
        laptopsSplit: this.laptopsSplit,
        containersSplit: this.containersSplit,
        processing_instruction_id: this.id,
        allInOneSplit: this.allInOneSplit,
        desktopsSplit: this.desktopsSplit,
        containersDevicesSplit: this.containersDevicesSplit,
        ssdSplit: this.ssdSplit,
      };

      this._processingSerice
        .newItemSplitManifest(this.token, this.itemManifestID, data)
        .subscribe((response) => {
          if (response.status === "success") {
            let batch;

            batch = response.data.batch;

            if (this.hardDrivesSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "HD-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.laptopsSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "LP-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.allInOneSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "ALL-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.desktopsSplit != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "DK-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            this.getItemsManifest();
            this.closeManifest();
          }
        });
    }
  }

  saveManifest() {
    this.saveManifestB = true;
    let data: any;
    data = {
      hardDrives: this.hardDrives,
      mobileDevices: this.mobileDevices,
      laptops: this.laptops,
      containers: this.containers,
      processing_instruction_id: this.id,
      containersmdl: this.containersmdl,
      allInOne: this.allInOne,
      desktops: this.desktops,
      containersDevices: this.containersDevices,
    };

    if (this.itemManifestID === null) {
      this._processingSerice
        .newItemManifest(this.token, data)
        .subscribe((response) => {
          if (response.status === "success") {
            let batch;

            batch = response.data.batch;

            if (this.hardDrives != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "HD-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                extra: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.mobileDevices != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "MB-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                extra: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.laptops != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "LP-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                extra: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.allInOne != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "ALL-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                batch: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            if (this.desktops != 0) {
              this.myWebSocket.next({
                notify: "1",
                data: this.id,
                type: "DK-PI",
                token: this.token,
                action: "NEW", // NEW ó UPDATE ó DELETE
                extra: batch,
              });

              this.myWebSocket.asObservable().subscribe(
                (msg) => {
                  let msgCoded;
                  msgCoded = JSON.stringify(msg);
                  console.log("message received: " + msgCoded);
                  this.numberNotifications = msg.numberNotifications;
                  this.notificationsData = msg.data;
                },
                // Called whenever there is a message from the server
                (err) => console.log(err),
                // Called if WebSocket API signals some kind of error
                () => console.log("complete")
                // Called when connection is closed (for whatever reason)
              );
            }

            this.getItemsManifest();
            this.closeManifest();
          }
        });
    } else {
      this._processingSerice
        .editItemManifest(this.token, this.itemManifestID, data)
        .subscribe((response) => {
          if (response.status === "success") {
            this.getItemsManifest();
            this.closeManifest();
          }
        });
    }
  }

  public deletManiest_id = null;

  deleteManifest() {
    this._processingSerice
      .removeItemManifest(this.token, this.deletManiest_id)
      .subscribe((response) => {
        if (response.status === "success") {
          this.getItemsManifest();
          this.closeManifest();
          this.deletManiest_id = null;
        } else {
          alert(response.msg);
        }
      });
  }

  showItemManifest(item) {
    this.newManifest = true;
    this.itemManifestID = item.id;
    this.hardDrives = item.hardDrives;
    this.ssd = item.sdd;
    this.mobileDevices = item.mobileDevices;
    this.laptops = item.laptops;
    this.containers = item.containers;
    this.containersmdl = item.containersmdl;
    this.allInOne = item.allInOne;
    this.desktops = item.desktops;
    this.containersDevices = item.containersDevices;
  }

  splitItem(item) {
    this.closeItem();
    this.splitManifest = true;
    this.itemManifestID = item.id;
    this.hardDrivesDone = item.hardDrivesDone;
    this.laptopsDone = item.laptopsDone;
    this.allInOneDone = item.allinoneDone;
    this.desktopsDone = item.desktopsDone;
    this.hardDrives = item.hardDrives;
    this.laptops = item.laptops;
    this.allInOne = item.allInOne;
    this.desktops = item.desktops;
    this.ssd = item.ssd;
    this.ssdDone = item.ssdDone;
  }

  splitItemNew(item) {
    this.itemManifestID = item.id;
    this.hardDrivesDone = item.hardDrivesDone;
    this.laptopsDone = item.laptopsDone;
    this.allInOneDone = item.allinoneDone;
    this.desktopsDone = item.desktopsDone;
    this.hardDrives = item.hardDrives;
    this.laptops = item.laptops;
    this.allInOne = item.allInOne;
    this.desktops = item.desktops;
    this.ssd = item.ssd;
    this.ssdDone = item.ssdDone;
    item.dosplit = true;
    this.item_split_status = item.status ? item.status : "";
    this.errorHardDrives = false;
    this.errorLaptops = false;
    this.errorAllInOne = false;
    this.errorDesktops = false;
    this.saveSplit = false;
    this.status_container_type = item.containerType;
  }

  closeManifest() {
    this.newManifest = false;
    this.splitManifest = false;
    this.itemManifestID = null;
    this.hardDrives = 0;
    this.mobileDevices = 0;
    this.laptops = 0;
    this.containers = 0;
    this.containersmdl = 0;
    this.desktops = 0;
    this.allInOne = 0;
    this.containersDevices = 0;

    this.ssdSplit = 0;

    this.hardDrivesSplit = 0;
    this.hardDrivesDone = 0;
    this.laptopsSplit = 0;
    this.laptopsDone = 0;
    this.containersSplit = 0;
    this.desktopsSplit = 0;
    this.desktopsDone = 0;
    this.allInOneSplit = 0;
    this.allInOneDone = 0;
    this.containersDevicesSplit = 0;
    this.errorHardDrives = false;
    this.errorLaptops = false;
    this.errorAllInOne = false;
    this.errorDesktops = false;
    this.saveSplit = false;
    this.saveManifestB = false;
  }

  deleteItem() {
    this.delete_id.emit(this.item.id);
  }
  closeBatch() {
    console.log("Close button clicked in child");
    this.closeNewBatch.emit(); // Emite el evento
  }
  notifyError(mensaje: string, from: any = "bottom", align: any = "right") {
    const type = [
      "",
      "info",
      "success",
      "warning",
      "danger",
      "rose",
      "primary",
    ];

    const color = Math.floor(Math.random() * 6 + 1);

    $.notify(
      {
        icon: "notifications",
        message: mensaje,
      },
      {
        type: "danger",
        timer: 500,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
          '<i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"' +
          'style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }

  notifySuccess(mensaje: string, from: any = "bottom", align: any = "right") {
    const type = [
      "",
      "info",
      "success",
      "warning",
      "danger",
      "rose",
      "primary",
    ];

    const color = Math.floor(Math.random() * 6 + 1);

    $.notify(
      {
        icon: "notifications",
        message: mensaje,
      },
      {
        type: "success",
        timer: 500,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
          '<i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar"' +
          'aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }
}
